import { useEffect, useState } from 'react';
import PitchDeck from '../../Assets/img/OverviewAssets/First.png';
import JoeLinkedIn from '../../Assets/img/OverviewAssets/Second.png';
import Loading from '../../Loading';
import LoginFullPagePaul from '../LoginMenu/LoginFullPagePaul';
import Footer from './Footer';

import Testimonials_Mini from '../../Assets/img/OverviewAssets/image (7).png';

// import MultiMedia from '../../Assets/img/OverviewAssets/NewEricMade.mp4';
import SalesExperience from '../../Assets/CaroselImages/Sales Experience with sound 6.0Latest.mp4';
import MultiMedia from '../../Assets/img/OverviewAssets/Amy Loop (1).mp4';
import Clients from '../../Assets/img/OverviewAssets/Hear From Our Clients 2022-2023.mp4';
import InvestorVideo from '../../Assets/img/OverviewAssets/Invest in the Amazon of B2B Services _ Salesmrkt.mp4';
import DemoVideo from '../../Assets/img/OverviewAssets/Salesmrkt Demo 3.0 with VO.mp4';
import MrktBeta from '../../Assets/img/OverviewAssets/Third.svg';
import Video from '../../Assets/img/OverviewAssets/Thumbnail.mp4';
// import { IoMdInformationCircleOutline } from 'react-icons/io';
import { Helmet } from 'react-helmet';
import { IoMdInformationCircle } from 'react-icons/io';
import NavBarNoInvest from '../NavBar/NavBarNoInvest';
import VideoEmbed from '../YoutubeEmbed/VideoEmbed';
const SalesmrktOverviewNew = () => {
	const [bundles, setBundles] = useState(false);
	const [navOne, setNavOne] = useState(false);
	const [navTwo, setNavTwo] = useState(false);
	const [navThree, setNavThree] = useState(false);
	const [navFour, setNavFour] = useState(true);
	const [exploreButton, setExploreButton] = useState(false);
	const [resources, setresources] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isIdle, setIsIdle] = useState(false);
	const [isOpen, setOpen] = useState(false);
	const [popUpHasBeenShown, setPopUpHasBeenShown] = useState(false);
	const [LoginMenuOpener, setLoginMenuOpener] = useState(false);
	const [LetsTalkOpener, setLetsTalkOpener] = useState(false);
	const [FooterSelected, setFooterSelected] = useState(18);
	const [videoOpener, setVideoOpener] = useState(false);
	const [videoOpenerDemo, setVideoOpenerDemo] = useState(false);
	const [videoOpenerCustomer, setVideoOpenerCustomer] = useState(false);
	const [videoOpenerSalesExperience, setVideoOpenerExperience] =
		useState(false);
	const handleButtonClick = () => {
		setVideoOpener(true);
	};
	const handleCloseOverlay = () => {
		setVideoOpener(false);
	};
	const handleButtonClickDemo = () => {
		setVideoOpenerDemo(true);
	};
	const handleCloseOverlayDemo = () => {
		setVideoOpenerDemo(false);
	};
	const handleButtonClickSales = () => {
		setVideoOpenerExperience(true);
	};
	const handleCloseOverlaySales = () => {
		setVideoOpenerExperience(false);
	};
	const handleButtonClickCustomer = () => {
		setVideoOpenerCustomer(true);
	};
	const handleCloseOverlayCustomer = () => {
		setVideoOpenerCustomer(false);
	};
	useEffect(() => {
		// Simulate loading for 1 second
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 2200);

		// Clean up the timer on component unmount
		return () => clearTimeout(timer);
	}, []);
	return (
		<div className='overflow-hidden'>
			<Helmet>
				<title>Salesmrkt Investor Overview</title>
			</Helmet>
			<Loading isLoading={isLoading} />

			<LoginFullPagePaul
				LoginMenuOpener={LoginMenuOpener}
				setLoginMenuOpener={setLoginMenuOpener}
			/>

			<NavBarNoInvest
				LetsTalkOpener={LetsTalkOpener}
				setLetsTalkOpener={setLetsTalkOpener}
				Four={navFour}
				setNumber={setFooterSelected}
				setFour={setNavFour}
				budnles={bundles}
				setBundles={setBundles}
				setOne={setNavOne}
				setTwo={setNavTwo}
				setThree={setNavThree}
				One={navOne}
				Two={navTwo}
				Three={navThree}
				setExploreButton={setExploreButton}
				recources={resources}
				setRecources={setresources}
				isOpen={isOpen}
				setOpen={setOpen}
				LoginMenuOpener={LoginMenuOpener}
				setLoginMenuOpener={setLoginMenuOpener}
			/>
			<div className=' absolute hidden xl:flex  right-[50px] top-[150px] gap-1'>
				<a
					href='https://salesmrkt.com/'
					target='_blank'
					className='group flex flex-col items-end justify-end'
					rel='noopener noreferrer'>
					<svg
						className=' w-[150px] bgred'
						width=''
						height=''
						viewBox='0 0 161 31'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M9.35867 22.9785C11.4875 22.9785 12.5533 22.3715 12.5533 21.0777C12.5533 20.0518 10.8035 19.2139 7.34105 18.6041C2.89253 17.7919 0.609854 15.8142 0.569957 12.6566C0.569957 8.31922 3.9897 6.26452 8.59783 6.19043C11.1835 6.19043 13.2372 6.76039 14.759 7.9003C16.2447 9.08011 17.0436 10.7159 17.1558 12.8077H13.9639C12.7842 12.7706 12.0232 12.3517 11.7183 11.5537C11.3763 10.6788 10.3504 10.183 8.67475 10.183C6.69415 10.183 5.69957 10.7244 5.69957 11.7447C5.69957 12.7649 6.99337 13.5685 9.618 14.0644C13.0378 14.7483 15.2863 15.6232 16.3891 16.652C16.8481 17.1252 17.2087 17.6847 17.4504 18.298C17.692 18.9114 17.8098 19.5665 17.7969 20.2257C17.7969 25.1728 13.9155 26.9967 8.59208 26.9967C5.78222 26.9967 3.65342 26.3982 2.27982 25.2099C0.758043 24.07 0 22.3173 0 19.9977H5.17236C5.28635 22.2034 6.88223 22.9642 9.35867 22.9642'
							fill='black'
						/>
						<path
							d='M25.2207 11.7447H20.1623C20.7693 8.01715 23.3939 6.19043 28.0363 6.19043C33.5904 6.19043 36.4032 8.01715 36.5172 11.7447V18.5842C36.5172 24.1384 33.1715 26.612 27.7313 26.991C22.8867 27.3729 19.5524 25.1272 19.5524 20.6759C19.6636 15.8541 23.1659 14.5574 28.2642 14.0644C30.4329 13.7965 31.5358 13.1525 31.5358 12.0467C31.4218 10.9068 30.3559 10.3368 28.2642 10.3368C26.4745 10.3368 25.4857 10.7928 25.2207 11.7447ZM31.6098 18.3618V16.4981C30.3095 17.034 28.9598 17.4415 27.5803 17.715C25.5626 18.0968 24.5367 19.0487 24.5367 20.5306C24.6507 22.1292 25.4857 22.8902 27.0844 22.8902C29.9 22.8902 31.6098 21.2145 31.6098 18.3618Z'
							fill='black'
						/>
						<path
							d='M44.7732 3.22362V26.6175H39.7119V0.75H42.3366C42.9852 0.762642 43.6032 1.02847 44.0585 1.49068C44.5138 1.95289 44.7702 2.57483 44.7732 3.22362Z'
							fill='black'
						/>
						<path
							d='M56.603 27.0737C50.5159 26.8827 47.4838 23.3462 47.4838 16.4981C47.4838 9.65008 50.5672 6.23888 56.6914 6.19043C63.0806 6.19043 66.0957 10.1089 65.7053 17.9828H52.6846C52.8755 21.0635 54.2064 22.6223 56.6743 22.6223C57.8513 22.6223 58.9541 22.1292 59.9458 21.1775C60.1613 20.9399 60.4258 20.7521 60.721 20.6271C61.0163 20.5021 61.3353 20.4429 61.6558 20.4536H65.3833C64.2803 24.7283 61.5418 27.0737 56.5974 27.0737M52.7615 14.3693H60.3306C60.0257 11.7047 58.7718 10.3368 56.603 10.3368C54.4343 10.3368 53.1406 11.7047 52.7615 14.3693Z'
							fill='black'
						/>
						<path
							d='M76.8396 22.9779C78.9713 22.9779 80.0342 22.3709 80.0342 21.0772C80.0342 20.0513 78.2844 19.2133 74.8248 18.6035C70.3734 17.8056 68.0908 15.8278 68.0537 12.6703C68.0537 8.33289 71.4734 6.2782 76.0787 6.2041C78.6663 6.2041 80.721 6.77406 82.2428 7.91398C83.725 9.09375 84.5233 10.7296 84.6392 12.8213H81.442C80.265 12.7843 79.5041 12.3653 79.1992 11.5674C78.8573 10.6925 77.8284 10.1967 76.1557 10.1967C74.1779 10.1967 73.189 10.7296 73.189 11.7583C73.189 12.7871 74.4828 13.5822 77.1074 14.0781C80.5272 14.762 82.7757 15.6369 83.8783 16.6657C84.3367 17.1393 84.6975 17.6988 84.9392 18.312C85.1809 18.9253 85.2984 19.5803 85.2867 20.2393C85.2867 25.1865 81.4049 27.0104 76.0787 27.0104C73.2631 27.0104 71.1343 26.4034 69.7636 25.2236C68.2418 24.0837 67.4838 22.331 67.4838 20.0113H72.6703C72.7843 22.2171 74.3802 22.9779 76.8539 22.9779'
							fill='black'
						/>
						<path
							d='M87.4883 14.7854V26.6177H92.6175V13.7595C92.655 11.6677 93.795 10.6418 96.0375 10.6418C98.28 10.6418 99.4233 11.6677 99.5375 13.7595V26.6177H104.635V13.8364C104.672 11.7447 105.815 10.7017 108.055 10.7017C110.295 10.7017 111.441 11.7304 111.555 13.8364V24.184C111.555 25.7798 112.392 26.5778 114.065 26.6918H116.69V14.8623C116.727 9.12 113.874 6.26452 108.141 6.26452C105.553 6.26452 103.581 6.79744 102.13 7.9003C100.682 6.76039 98.7108 6.19043 96.12 6.19043C90.375 6.19043 87.485 9.04021 87.485 14.7854'
							fill='url(#paint0_linear_2570_1989)'
						/>
						<path
							d='M129.982 6.49512C123.247 6.49512 119.785 9.72676 119.634 16.2328V26.6174H124.763V16.1559C124.763 13.2263 126.171 11.7444 128.987 11.7444H130.697V6.49512H129.982Z'
							fill='url(#paint1_linear_2570_1989)'
						/>
						<path
							d='M151.626 0.75V22.7361C151.588 24.9818 152.5 26.1558 154.401 26.3497C156.171 26.5331 157.955 26.5465 159.728 26.3895V22.548H158.163C157.174 22.548 156.678 22.0892 156.678 21.2542V10.1087H157.211C157.543 10.1161 157.874 10.056 158.183 9.932C158.493 9.80792 158.773 9.62258 159.008 9.38717C159.243 9.15167 159.428 8.87099 159.552 8.56202C159.675 8.25304 159.735 7.9222 159.728 7.58948V6.49517H156.684V3.29771C156.684 1.96686 155.581 0.75 154.25 0.75H151.626Z'
							fill='url(#paint2_linear_2570_1989)'
						/>
						<path
							d='M133.057 0.77832V26.6458H138.117V19.3048C138.098 19.069 138.17 18.8347 138.319 18.6506C138.467 18.4664 138.681 18.3466 138.916 18.3159C139.563 18.3159 140.211 18.8858 140.857 20.0258L144.43 26.6458H150.517L143.481 14.7138L150.44 7.24449H144.356L142.102 9.82925L139.417 12.907L138.117 14.3974V3.25194C138.115 2.60315 137.858 1.98121 137.403 1.519C136.948 1.05679 136.33 0.790962 135.682 0.77832H133.057Z'
							fill='url(#paint3_linear_2570_1989)'
						/>
					</svg>
					<h3 className='text-black text-end w-full group-hover:text-lime-500 transition-all duration-300 ease-in text-sm '>
						Salesmrkt.com
					</h3>
				</a>
			</div>
			{videoOpener && (
				<div>
					<VideoEmbed
						videoPath={InvestorVideo}
						onClose={handleCloseOverlay}
					/>
					{/* <
						videoId='9vKzzf3QKvE'
						onClose={handleCloseOverlay}
					/> */}
				</div>
			)}
			{videoOpenerDemo && (
				<div>
					<VideoEmbed
						videoPath={DemoVideo}
						onClose={handleCloseOverlayDemo}
					/>
				</div>
			)}
			{videoOpenerSalesExperience && (
				<div>
					<VideoEmbed
						videoPath={SalesExperience}
						onClose={handleCloseOverlaySales}
					/>
				</div>
			)}
			{videoOpenerCustomer && (
				<div>
					<VideoEmbed
						videoPath={Clients}
						onClose={handleCloseOverlayCustomer}
					/>
				</div>
			)}
			<div className='w-full h-full mt-[100px] mb-[10px] lg:mb-[50px] flex flex-col gap-10 items-center justify-center'>
				<div className='2xl:w-[95%] grid grid-cols-1 xl:grid-cols-6     p-3'>
					<div className='flex   col-span-2     w-full  flex-col  items-center justify-center '>
						<h1 className='text-lime-500  flex xl:hidden   font-bold      text-center  lg:-mb-4 lg:text-start text-5xl xl:text-7xl 2xl:text-8xl '>
							The Amazon of
						</h1>
						<h1 className='text-black  font-bold flex xl:hidden  mb-6 text-center lg:mt-0 lg:mb-0 lg:text-start text-5xl xl:text-7xl 2xl:text-8xl '>
							B2B Services
						</h1>
						<div className='cursor-pointer   flex flex-col gap-3 items-center   relative'>
							<div className='group  relative flex h-fit flex-col items-center gap-3'>
								<video
									onClick={() => setVideoOpener(true)}
									muted
									autoPlay
									loop
									playsInline
									disablePictureInPicture
									preload={'auto'}
									className='w-full p-1 aspect-square     '
									src={Video}></video>
								<div
									onClick={() => setVideoOpener(true)}
									className='flex backdrop-blur-lg absolute bottom-[10px] bg-zinc-900/40 pt-1 pb-1 rounded-lg  w-[250px]   items-center gap-2 justify-center'>
									<div className=' relative transition-all ease-in-out duration-300 '>
										<svg
											width='35'
											height='35'
											viewBox='0 0 72 71'
											fill='none'
											className='hidden md:flex'
											xmlns='http://www.w3.org/2000/svg'>
											<path
												className='group-hover:drawn  group-hover:stroke-lime-500 stroke-white transition-all ease-in-out duration-300 '
												d='M28.3666 35.4769C28.3666 38.8059 28.3666 42.1349 28.3666 45.464C28.3666 47.3134 29.3969 47.8683 31.036 46.9435C34.8761 44.7704 38.7162 42.5973 42.5563 40.3779C44.6168 39.222 46.6774 38.0661 48.6911 36.864C50.0492 36.078 50.0492 34.8758 48.6911 34.0436C48.5974 33.9973 48.4569 33.9048 48.3633 33.8586C42.6031 30.5758 36.7961 27.293 31.036 24.0102C29.3969 23.0855 28.4134 23.6404 28.3666 25.4898C28.3666 28.8651 28.3666 32.1941 28.3666 35.4769Z'
												stroke='white'
												strokeWidth='3'
												strokeMiterlimit='10'
											/>
											<circle
												className=' group-hover:stroke-lime-500 stroke-white  transition-all ease-in-out duration-300 '
												cx='36'
												cy='36'
												r='32.5'
												stroke='white'
												strokeWidth='3'
											/>
										</svg>
										<svg
											width='42'
											height='42'
											viewBox='0 0 72 71'
											className='flex md:hidden'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'>
											<path
												className='group-hover:drawn group-hover:stroke-lime-500 stroke-black transition-all ease-in-out duration-300 '
												d='M28.3666 35.4769C28.3666 38.8059 28.3666 42.1349 28.3666 45.464C28.3666 47.3134 29.3969 47.8683 31.036 46.9435C34.8761 44.7704 38.7162 42.5973 42.5563 40.3779C44.6168 39.222 46.6774 38.0661 48.6911 36.864C50.0492 36.078 50.0492 34.8758 48.6911 34.0436C48.5974 33.9973 48.4569 33.9048 48.3633 33.8586C42.6031 30.5758 36.7961 27.293 31.036 24.0102C29.3969 23.0855 28.4134 23.6404 28.3666 25.4898C28.3666 28.8651 28.3666 32.1941 28.3666 35.4769Z'
												stroke='white'
												strokeWidth='3'
												strokeMiterlimit='10'
											/>
											<circle
												className=' group-hover:stroke-lime-500 stroke-black  transition-all ease-in-out duration-300 '
												cx='36'
												cy='36'
												r='32.5'
												stroke='white'
												strokeWidth='3'
											/>
										</svg>
									</div>
									<div>
										<h4 className='font-bold group-hover:text-lime-500 transition-all duration-100 text-white'>
											1 Minute Overview
										</h4>
									</div>
								</div>
							</div>

							<div className='flex w-full relative group  max-w-[380px]  flex-col gap-4 mb-10 xl:mb-0 xl:gap-3'>
								<div className=" items-center  lg:flex opacity-100 group-hover:hidden absolute top-[0px] hidden xl:flex  w-[360px] justify-center  gap-3"><h3 className="text-black">Connect with the Founder Here</h3></div>
								<div className=' items-center hidden lg:flex opacity-100 group-hover:hidden absolute top-[30px]  w-[300px] justify-start ml-[92px] gap-3'>
									<IoMdInformationCircle className='w-[32px] text-lime-500  h-[32px] ' />
									<h3 className='text-lime-500'>More Info</h3>
								</div>
								<a
									className='p-2  lg:opacity-0 pointer-events-none group-hover:pointer-events-auto group-hover:opacity-100 transition-all duration-300 ease-in   cursor-pointer group flex gap-3 items-center justify-start  rounded w-full  text-center  font-semibold border-lime-500 border   overflow-hidden group  relative hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400 text-black hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 '
									href='https://calendly.com/salesbox-meet/investor-relations'
									target='_blank'
									rel='noopener noreferrer'>
									<svg
										className='fill-black hidden md:flex  transition-all z-20'
										width='100'
										height='20'
										viewBox='0 0 234 57'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'>
										<path
											d='M139.068 22.8091C142.68 22.8091 146.097 25.0233 146.834 29.7991H130.758C131.379 25.6055 134.524 22.8091 139.068 22.8091ZM146.291 36.867C145.049 38.7695 142.68 40.2456 139.418 40.2456C134.952 40.2456 131.495 37.7988 130.68 33.4494H150.873C150.99 32.8282 151.029 32.207 151.029 31.5858C151.029 24.8285 146.33 18.8482 139.029 18.8482C131.495 18.8482 126.409 24.4021 126.409 31.5079C126.409 38.7306 131.573 44.1676 139.34 44.1676C144.155 44.1676 147.805 41.9934 149.941 38.7306L146.291 36.867ZM120.234 8.40274H124.428V43.5853H120.234V8.40274ZM174.368 28.7894V43.5853H170.173V29.0231C170.173 25.0622 167.921 22.8481 164.193 22.8481C160.349 22.8481 157.203 25.1002 157.203 30.8088V43.5853H153.009V19.5084H157.203V22.9649C158.99 20.1296 161.63 18.8872 165.009 18.8872C170.679 18.8482 174.368 22.6154 174.368 28.7894ZM197.473 31.5079C197.473 26.5763 193.746 22.887 188.891 22.887C184.076 22.887 180.348 26.6152 180.348 31.5079C180.348 36.4395 184.076 40.1288 188.891 40.1288C193.784 40.1677 197.473 36.4395 197.473 31.5079ZM201.668 8.40274V43.5853H197.473V39.4297C195.531 42.3819 192.463 44.2065 188.348 44.2065C181.668 44.2065 176.153 38.6537 176.153 31.5469C176.153 24.44 181.629 18.8872 188.348 18.8872C192.425 18.8872 195.531 20.7129 197.473 23.664V8.44066H201.668V8.40274ZM205.046 8.40274H209.24V43.5853H205.046V8.40274ZM112.778 31.5079C112.778 26.5763 109.05 22.887 104.195 22.887C99.3805 22.887 95.6524 26.6152 95.6524 31.5079C95.6524 36.4395 99.3805 40.1288 104.195 40.1288C109.05 40.1677 112.778 36.4395 112.778 31.5079ZM116.972 19.4694V43.5464H112.778V39.3917C110.836 42.3429 107.769 44.1676 103.691 44.1676C97.0116 44.1676 91.4967 38.6147 91.4967 31.5079C91.4967 24.4021 96.9726 18.8482 103.691 18.8482C107.769 18.8482 110.875 20.6739 112.778 23.6251V19.4694H116.972ZM85.245 38.9253C78.488 41.4101 70.9932 37.9546 68.469 31.1973C65.9836 24.44 69.4399 16.9457 76.1969 14.4209C80.5462 12.829 85.4391 13.645 89.0118 16.5962C89.7497 17.2173 90.4098 17.8775 90.9924 18.6545L94.6037 16.0139C88.7012 8.32483 77.6726 6.84873 69.9835 12.7511C62.2945 18.6545 60.8188 29.6833 66.7215 37.3723C72.6242 45.0604 83.6528 46.5365 91.3419 40.6341C91.3809 40.5952 91.3809 40.5952 91.4198 40.5562L89.0118 36.7501C87.9245 37.6829 86.643 38.42 85.245 38.9253ZM229.472 19.4694V33.1388C229.472 37.5661 226.909 40.3625 222.987 40.3625C219.065 40.3625 216.23 37.5661 216.23 33.1388V19.4694H211.997V32.7503C211.997 39.7023 216.347 44.2065 223.026 44.2065C228.811 44.2065 229.705 40.5562 229.705 40.4783V45.41C229.705 50.3037 227.569 53.0221 223.142 53.0221C219.88 53.0221 217.084 50.6142 216.657 47.3904L212.851 48.7117C213.978 53.4875 218.249 56.8662 223.142 56.8662C230.016 56.8662 233.743 52.362 233.743 45.41V19.5084H229.472V19.4694Z'
											fill=''
										/>
										<path
											d='M34.8774 33.5273C33.2853 34.9644 31.266 36.7501 27.6156 36.7501H25.4021C22.7614 36.7501 20.3538 35.7793 18.6452 34.0705C16.9753 32.3628 16.0433 30.0328 16.0433 27.508V24.5179C16.0433 21.9942 16.9753 19.6642 18.6452 17.9554C20.3538 16.2076 22.7614 15.2758 25.4021 15.2758H27.5767C31.2271 15.2758 33.2464 17.0615 34.8387 18.4987C36.5084 19.9748 37.9452 21.2561 41.7898 21.2561C42.3722 21.2561 42.9548 21.2172 43.5372 21.1003V21.0613C43.3042 20.4791 43.0325 19.9358 42.7218 19.3925L40.1588 14.9263C37.79 10.8485 33.4406 8.3248 28.703 8.3248H23.6157C18.8782 8.3248 14.5288 10.8485 12.1599 14.9263L9.59694 19.3925C7.2281 23.4692 7.2281 28.5177 9.59694 32.5955L12.1599 37.0607C14.5288 41.1384 18.8782 43.6632 23.6157 43.6632H28.7417C33.4794 43.6632 37.8288 41.1384 40.1976 37.0607L42.7606 32.5955C43.0712 32.0522 43.3431 31.5079 43.5761 30.9256V30.8867C42.9936 30.8088 42.4111 30.7309 41.8286 30.7309C37.9841 30.7698 36.5473 32.0522 34.8774 33.5273Z'
											fill=''
										/>
										<path
											d='M27.6157 17.9554H25.4022C21.4024 17.9554 18.7617 20.8287 18.7617 24.479V27.4691C18.7617 31.1583 21.4024 33.9937 25.4022 33.9937H27.5769C33.4408 33.9937 32.9748 28.0134 41.8287 28.0134C42.683 28.0134 43.4986 28.0903 44.314 28.2461C44.5859 26.7321 44.5859 25.1781 44.314 23.664C43.4986 23.8188 42.6442 23.8967 41.8287 23.8967C32.9748 23.9357 33.4408 17.9554 27.6157 17.9554Z'
											fill=''
										/>
										<path
											d='M49.4005 30.4592C47.886 29.3727 46.1774 28.5957 44.3134 28.2851V28.324C44.158 29.2168 43.925 30.0707 43.5755 30.8867C45.09 31.1194 46.5268 31.7026 47.7695 32.6344V32.6734C44.0804 44.634 31.4207 51.3133 19.4601 47.6241C7.49941 43.9348 0.820035 31.2752 4.50917 19.3146C8.19841 7.35407 20.8581 0.674388 32.8187 4.36394C39.964 6.57707 45.556 12.1688 47.7695 19.3146V19.3536C46.5268 20.2464 45.09 20.8287 43.5755 21.0614C43.925 21.8773 44.158 22.7702 44.3134 23.6251V23.664C46.1385 23.3145 47.886 22.5764 49.4005 21.4888C50.8374 20.4012 50.5655 19.1978 50.3325 18.4987C46.2161 5.10097 32.0032 -2.39345 18.6057 1.72283C5.20817 5.83902 -2.28661 20.0527 1.82973 33.4494C5.94602 46.8471 20.1591 54.3424 33.5565 50.2257C41.5562 47.7399 47.8472 41.488 50.3325 33.4494C50.5655 32.7503 50.8762 31.5468 49.4005 30.4592Z'
											fill=''
										/>
										<path
											d='M43.5718 21.0624C42.9894 21.1393 42.4068 21.2172 41.8244 21.2172C37.9798 21.2172 36.543 19.9358 34.8732 18.4597C33.2422 17.0236 31.2617 15.2369 27.6113 15.2369H25.3979C22.7572 15.2369 20.3495 16.2076 18.6409 17.9164C16.9711 19.6252 16.0391 21.9552 16.0391 24.479V27.4691C16.0391 29.9939 16.9711 32.3238 18.6409 34.0326C20.3495 35.7794 22.7572 36.7122 25.3979 36.7122H27.5726C31.2229 36.7122 33.2422 34.9255 34.8344 33.4883C36.5041 32.0132 37.941 30.7309 41.7855 30.7309C42.368 30.7309 42.9505 30.7698 43.533 30.8867C43.8825 30.0707 44.1155 29.1779 44.2708 28.324V28.2851C43.4554 28.1292 42.601 28.0524 41.7855 28.0524C32.9316 28.0524 33.3976 34.0326 27.5337 34.0326H25.3979C21.398 34.0326 18.7574 31.1583 18.7574 27.4691V24.479C18.7574 20.7897 21.398 17.9554 25.3979 17.9554H27.5726C33.4364 17.9554 32.9704 23.9357 41.8244 23.9357C42.6787 23.9357 43.4942 23.8578 44.3097 23.703V23.664C44.1544 22.7702 43.9214 21.9163 43.5718 21.0624Z'
											fill='white'
										/>
										<path
											d='M43.5718 21.0624C42.9894 21.1393 42.4068 21.2172 41.8244 21.2172C37.9798 21.2172 36.543 19.9358 34.8732 18.4597C33.2422 17.0236 31.2617 15.2369 27.6113 15.2369H25.3979C22.7572 15.2369 20.3495 16.2076 18.6409 17.9164C16.9711 19.6252 16.0391 21.9552 16.0391 24.479V27.4691C16.0391 29.9939 16.9711 32.3238 18.6409 34.0326C20.3495 35.7794 22.7572 36.7122 25.3979 36.7122H27.5726C31.2229 36.7122 33.2422 34.9255 34.8344 33.4883C36.5041 32.0132 37.941 30.7309 41.7855 30.7309C42.368 30.7309 42.9505 30.7698 43.533 30.8867C43.8825 30.0707 44.1155 29.1779 44.2708 28.324V28.2851C43.4554 28.1292 42.601 28.0524 41.7855 28.0524C32.9316 28.0524 33.3976 34.0326 27.5337 34.0326H25.3979C21.398 34.0326 18.7574 31.1583 18.7574 27.4691V24.479C18.7574 20.7897 21.398 17.9554 25.3979 17.9554H27.5726C33.4364 17.9554 32.9704 23.9357 41.8244 23.9357C42.6787 23.9357 43.4942 23.8578 44.3097 23.703V23.664C44.1544 22.7702 43.9214 21.9163 43.5718 21.0624Z'
											fill='white'
										/>
									</svg>
									<svg
										className='fill-black flex md:hidden  transition-all z-20'
										width='70'
										height='20'
										viewBox='0 0 234 57'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'>
										<path
											d='M139.068 22.8091C142.68 22.8091 146.097 25.0233 146.834 29.7991H130.758C131.379 25.6055 134.524 22.8091 139.068 22.8091ZM146.291 36.867C145.049 38.7695 142.68 40.2456 139.418 40.2456C134.952 40.2456 131.495 37.7988 130.68 33.4494H150.873C150.99 32.8282 151.029 32.207 151.029 31.5858C151.029 24.8285 146.33 18.8482 139.029 18.8482C131.495 18.8482 126.409 24.4021 126.409 31.5079C126.409 38.7306 131.573 44.1676 139.34 44.1676C144.155 44.1676 147.805 41.9934 149.941 38.7306L146.291 36.867ZM120.234 8.40274H124.428V43.5853H120.234V8.40274ZM174.368 28.7894V43.5853H170.173V29.0231C170.173 25.0622 167.921 22.8481 164.193 22.8481C160.349 22.8481 157.203 25.1002 157.203 30.8088V43.5853H153.009V19.5084H157.203V22.9649C158.99 20.1296 161.63 18.8872 165.009 18.8872C170.679 18.8482 174.368 22.6154 174.368 28.7894ZM197.473 31.5079C197.473 26.5763 193.746 22.887 188.891 22.887C184.076 22.887 180.348 26.6152 180.348 31.5079C180.348 36.4395 184.076 40.1288 188.891 40.1288C193.784 40.1677 197.473 36.4395 197.473 31.5079ZM201.668 8.40274V43.5853H197.473V39.4297C195.531 42.3819 192.463 44.2065 188.348 44.2065C181.668 44.2065 176.153 38.6537 176.153 31.5469C176.153 24.44 181.629 18.8872 188.348 18.8872C192.425 18.8872 195.531 20.7129 197.473 23.664V8.44066H201.668V8.40274ZM205.046 8.40274H209.24V43.5853H205.046V8.40274ZM112.778 31.5079C112.778 26.5763 109.05 22.887 104.195 22.887C99.3805 22.887 95.6524 26.6152 95.6524 31.5079C95.6524 36.4395 99.3805 40.1288 104.195 40.1288C109.05 40.1677 112.778 36.4395 112.778 31.5079ZM116.972 19.4694V43.5464H112.778V39.3917C110.836 42.3429 107.769 44.1676 103.691 44.1676C97.0116 44.1676 91.4967 38.6147 91.4967 31.5079C91.4967 24.4021 96.9726 18.8482 103.691 18.8482C107.769 18.8482 110.875 20.6739 112.778 23.6251V19.4694H116.972ZM85.245 38.9253C78.488 41.4101 70.9932 37.9546 68.469 31.1973C65.9836 24.44 69.4399 16.9457 76.1969 14.4209C80.5462 12.829 85.4391 13.645 89.0118 16.5962C89.7497 17.2173 90.4098 17.8775 90.9924 18.6545L94.6037 16.0139C88.7012 8.32483 77.6726 6.84873 69.9835 12.7511C62.2945 18.6545 60.8188 29.6833 66.7215 37.3723C72.6242 45.0604 83.6528 46.5365 91.3419 40.6341C91.3809 40.5952 91.3809 40.5952 91.4198 40.5562L89.0118 36.7501C87.9245 37.6829 86.643 38.42 85.245 38.9253ZM229.472 19.4694V33.1388C229.472 37.5661 226.909 40.3625 222.987 40.3625C219.065 40.3625 216.23 37.5661 216.23 33.1388V19.4694H211.997V32.7503C211.997 39.7023 216.347 44.2065 223.026 44.2065C228.811 44.2065 229.705 40.5562 229.705 40.4783V45.41C229.705 50.3037 227.569 53.0221 223.142 53.0221C219.88 53.0221 217.084 50.6142 216.657 47.3904L212.851 48.7117C213.978 53.4875 218.249 56.8662 223.142 56.8662C230.016 56.8662 233.743 52.362 233.743 45.41V19.5084H229.472V19.4694Z'
											fill=''
										/>
										<path
											d='M34.8774 33.5273C33.2853 34.9644 31.266 36.7501 27.6156 36.7501H25.4021C22.7614 36.7501 20.3538 35.7793 18.6452 34.0705C16.9753 32.3628 16.0433 30.0328 16.0433 27.508V24.5179C16.0433 21.9942 16.9753 19.6642 18.6452 17.9554C20.3538 16.2076 22.7614 15.2758 25.4021 15.2758H27.5767C31.2271 15.2758 33.2464 17.0615 34.8387 18.4987C36.5084 19.9748 37.9452 21.2561 41.7898 21.2561C42.3722 21.2561 42.9548 21.2172 43.5372 21.1003V21.0613C43.3042 20.4791 43.0325 19.9358 42.7218 19.3925L40.1588 14.9263C37.79 10.8485 33.4406 8.3248 28.703 8.3248H23.6157C18.8782 8.3248 14.5288 10.8485 12.1599 14.9263L9.59694 19.3925C7.2281 23.4692 7.2281 28.5177 9.59694 32.5955L12.1599 37.0607C14.5288 41.1384 18.8782 43.6632 23.6157 43.6632H28.7417C33.4794 43.6632 37.8288 41.1384 40.1976 37.0607L42.7606 32.5955C43.0712 32.0522 43.3431 31.5079 43.5761 30.9256V30.8867C42.9936 30.8088 42.4111 30.7309 41.8286 30.7309C37.9841 30.7698 36.5473 32.0522 34.8774 33.5273Z'
											fill=''
										/>
										<path
											d='M27.6157 17.9554H25.4022C21.4024 17.9554 18.7617 20.8287 18.7617 24.479V27.4691C18.7617 31.1583 21.4024 33.9937 25.4022 33.9937H27.5769C33.4408 33.9937 32.9748 28.0134 41.8287 28.0134C42.683 28.0134 43.4986 28.0903 44.314 28.2461C44.5859 26.7321 44.5859 25.1781 44.314 23.664C43.4986 23.8188 42.6442 23.8967 41.8287 23.8967C32.9748 23.9357 33.4408 17.9554 27.6157 17.9554Z'
											fill=''
										/>
										<path
											d='M49.4005 30.4592C47.886 29.3727 46.1774 28.5957 44.3134 28.2851V28.324C44.158 29.2168 43.925 30.0707 43.5755 30.8867C45.09 31.1194 46.5268 31.7026 47.7695 32.6344V32.6734C44.0804 44.634 31.4207 51.3133 19.4601 47.6241C7.49941 43.9348 0.820035 31.2752 4.50917 19.3146C8.19841 7.35407 20.8581 0.674388 32.8187 4.36394C39.964 6.57707 45.556 12.1688 47.7695 19.3146V19.3536C46.5268 20.2464 45.09 20.8287 43.5755 21.0614C43.925 21.8773 44.158 22.7702 44.3134 23.6251V23.664C46.1385 23.3145 47.886 22.5764 49.4005 21.4888C50.8374 20.4012 50.5655 19.1978 50.3325 18.4987C46.2161 5.10097 32.0032 -2.39345 18.6057 1.72283C5.20817 5.83902 -2.28661 20.0527 1.82973 33.4494C5.94602 46.8471 20.1591 54.3424 33.5565 50.2257C41.5562 47.7399 47.8472 41.488 50.3325 33.4494C50.5655 32.7503 50.8762 31.5468 49.4005 30.4592Z'
											fill=''
										/>
										<path
											d='M43.5718 21.0624C42.9894 21.1393 42.4068 21.2172 41.8244 21.2172C37.9798 21.2172 36.543 19.9358 34.8732 18.4597C33.2422 17.0236 31.2617 15.2369 27.6113 15.2369H25.3979C22.7572 15.2369 20.3495 16.2076 18.6409 17.9164C16.9711 19.6252 16.0391 21.9552 16.0391 24.479V27.4691C16.0391 29.9939 16.9711 32.3238 18.6409 34.0326C20.3495 35.7794 22.7572 36.7122 25.3979 36.7122H27.5726C31.2229 36.7122 33.2422 34.9255 34.8344 33.4883C36.5041 32.0132 37.941 30.7309 41.7855 30.7309C42.368 30.7309 42.9505 30.7698 43.533 30.8867C43.8825 30.0707 44.1155 29.1779 44.2708 28.324V28.2851C43.4554 28.1292 42.601 28.0524 41.7855 28.0524C32.9316 28.0524 33.3976 34.0326 27.5337 34.0326H25.3979C21.398 34.0326 18.7574 31.1583 18.7574 27.4691V24.479C18.7574 20.7897 21.398 17.9554 25.3979 17.9554H27.5726C33.4364 17.9554 32.9704 23.9357 41.8244 23.9357C42.6787 23.9357 43.4942 23.8578 44.3097 23.703V23.664C44.1544 22.7702 43.9214 21.9163 43.5718 21.0624Z'
											fill=''
										/>
										<path
											d='M43.5718 21.0624C42.9894 21.1393 42.4068 21.2172 41.8244 21.2172C37.9798 21.2172 36.543 19.9358 34.8732 18.4597C33.2422 17.0236 31.2617 15.2369 27.6113 15.2369H25.3979C22.7572 15.2369 20.3495 16.2076 18.6409 17.9164C16.9711 19.6252 16.0391 21.9552 16.0391 24.479V27.4691C16.0391 29.9939 16.9711 32.3238 18.6409 34.0326C20.3495 35.7794 22.7572 36.7122 25.3979 36.7122H27.5726C31.2229 36.7122 33.2422 34.9255 34.8344 33.4883C36.5041 32.0132 37.941 30.7309 41.7855 30.7309C42.368 30.7309 42.9505 30.7698 43.533 30.8867C43.8825 30.0707 44.1155 29.1779 44.2708 28.324V28.2851C43.4554 28.1292 42.601 28.0524 41.7855 28.0524C32.9316 28.0524 33.3976 34.0326 27.5337 34.0326H25.3979C21.398 34.0326 18.7574 31.1583 18.7574 27.4691V24.479C18.7574 20.7897 21.398 17.9554 25.3979 17.9554H27.5726C33.4364 17.9554 32.9704 23.9357 41.8244 23.9357C42.6787 23.9357 43.4942 23.8578 44.3097 23.703V23.664C44.1544 22.7702 43.9214 21.9163 43.5718 21.0624Z'
											fill=''
										/>
									</svg>
									Meet with the Founder {'>'}
								</a>
								<a
									className='p-2 lg:opacity-0 pointer-events-none group-hover:pointer-events-auto group-hover:opacity-100  cursor-pointer group flex gap-3 items-center justify-start  rounded w-full  text-center  font-semibold border-lime-500 border   overflow-hidden group  relative hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400 text-black hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300'
									href='https://wefunder.com/salesmrkt'
									target='_blank'
									rel='noopener noreferrer'>
									<svg
										className='flex md:hidden'
										width='70'
										height='20'
										viewBox='0 0 103 28'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'>
										<path
											className='fill-black  transition-all z-20'
											d='M27.6572 24.7402H35.697V22.7123H29.8711V20.3292H34.9397V18.3013H29.8711V15.9922H35.6242V13.9644H27.6572V24.7402ZM37.9266 24.7402H40.155V20.5216H45.2818V18.4493H40.155V16.0366H45.9518V13.9644H37.9266V24.7402ZM52.3812 24.903C55.2212 24.903 57.0127 23.3044 57.0127 20.0479V13.9644H54.7843V20.1516C54.7843 21.913 53.8813 22.8159 52.4102 22.8159C50.9392 22.8159 50.0508 21.8686 50.0508 20.0627V13.9644H47.8078V20.1368C47.8078 23.2896 49.5555 24.903 52.3812 24.903ZM59.5462 24.7402H61.7455V17.724L67.0183 24.7402H68.9259V13.9644H66.7121V20.7584L61.5998 13.9644H59.5462V24.7402ZM71.636 24.7402H75.7289C79.0645 24.7402 81.3657 22.3867 81.3657 19.3522V19.3227C81.3657 16.2883 79.0645 13.9644 75.7289 13.9644H71.636V24.7402ZM75.7289 16.0218C77.6949 16.0218 79.0207 17.3984 79.0207 19.3522V19.3819C79.0207 21.3357 77.6949 22.6827 75.7289 22.6827H73.8643V16.0218H75.7289ZM83.5979 24.7402H91.638V22.7123H85.8117V20.3292H90.8806V18.3013H85.8117V15.9922H91.5651V13.9644H83.5979V24.7402ZM96.096 19.219V16.0218H98.4993C99.6787 16.0218 100.407 16.5695 100.407 17.6056V17.6352C100.407 18.5825 99.7079 19.219 98.543 19.219H96.096ZM93.8676 24.7402H96.096V21.2321H98.0328L100.378 24.7402H103L100.349 20.8473C101.718 20.3588 102.664 19.2634 102.664 17.5168V17.4872C102.664 16.4955 102.359 15.6518 101.776 15.0597C101.077 14.3492 100.029 13.9644 98.6881 13.9644H93.8676V24.7402Z'
											fill=''
										/>
										<path
											className='stroke-black group-hover:stroke-white transition-all z-20'
											d='M2 18.9186L4.11812 14.3321C4.26983 14.0035 4.74024 14.0129 4.87866 14.3473L9.14299 24.6468C9.28725 24.9952 9.78435 24.9861 9.91571 24.6325L14.6591 11.8693C14.7865 11.5266 15.263 11.5041 15.4221 11.8333L20.5716 22.488C20.7384 22.8331 21.2438 22.7872 21.3457 22.4178L27.2499 1'
											stroke=''
											stroke-width='4.40977'
										/>
									</svg>
									<svg
										className='hidden md:flex'
										width='100'
										height='20'
										viewBox='0 0 103 28'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'>
										<path
											className='fill-black  transition-all z-20'
											d='M27.6572 24.7402H35.697V22.7123H29.8711V20.3292H34.9397V18.3013H29.8711V15.9922H35.6242V13.9644H27.6572V24.7402ZM37.9266 24.7402H40.155V20.5216H45.2818V18.4493H40.155V16.0366H45.9518V13.9644H37.9266V24.7402ZM52.3812 24.903C55.2212 24.903 57.0127 23.3044 57.0127 20.0479V13.9644H54.7843V20.1516C54.7843 21.913 53.8813 22.8159 52.4102 22.8159C50.9392 22.8159 50.0508 21.8686 50.0508 20.0627V13.9644H47.8078V20.1368C47.8078 23.2896 49.5555 24.903 52.3812 24.903ZM59.5462 24.7402H61.7455V17.724L67.0183 24.7402H68.9259V13.9644H66.7121V20.7584L61.5998 13.9644H59.5462V24.7402ZM71.636 24.7402H75.7289C79.0645 24.7402 81.3657 22.3867 81.3657 19.3522V19.3227C81.3657 16.2883 79.0645 13.9644 75.7289 13.9644H71.636V24.7402ZM75.7289 16.0218C77.6949 16.0218 79.0207 17.3984 79.0207 19.3522V19.3819C79.0207 21.3357 77.6949 22.6827 75.7289 22.6827H73.8643V16.0218H75.7289ZM83.5979 24.7402H91.638V22.7123H85.8117V20.3292H90.8806V18.3013H85.8117V15.9922H91.5651V13.9644H83.5979V24.7402ZM96.096 19.219V16.0218H98.4993C99.6787 16.0218 100.407 16.5695 100.407 17.6056V17.6352C100.407 18.5825 99.7079 19.219 98.543 19.219H96.096ZM93.8676 24.7402H96.096V21.2321H98.0328L100.378 24.7402H103L100.349 20.8473C101.718 20.3588 102.664 19.2634 102.664 17.5168V17.4872C102.664 16.4955 102.359 15.6518 101.776 15.0597C101.077 14.3492 100.029 13.9644 98.6881 13.9644H93.8676V24.7402Z'
											fill=''
										/>
										<path
											className='stroke-black  transition-all z-20'
											d='M2 18.9186L4.11812 14.3321C4.26983 14.0035 4.74024 14.0129 4.87866 14.3473L9.14299 24.6468C9.28725 24.9952 9.78435 24.9861 9.91571 24.6325L14.6591 11.8693C14.7865 11.5266 15.263 11.5041 15.4221 11.8333L20.5716 22.488C20.7384 22.8331 21.2438 22.7872 21.3457 22.4178L27.2499 1'
											stroke=''
											stroke-width='4.40977'
										/>
									</svg>
									Invest via Crowdfunding {'>'}
								</a>
								<a
									className='p-2 lg:opacity-0 pointer-events-none group-hover:pointer-events-auto group-hover:opacity-100 cursor-pointer group flex gap-5 items-center justify-start  rounded w-full text-center  font-semibold border-lime-500 border   overflow-hidden group  relative hover:bg-gradient-to-r hover:from-lime-500 hover:to-lime-400 text-black hover:ring-2 hover:ring-offset-2 hover:ring-lime-400 transition-all ease-out duration-300'
									href='https://calendly.com/salesbox-meet/investor-relations'
									target='_blank'
									rel='noopener noreferrer'>
									<svg
										className='fill-black hidden xl:flex  transition-all duration-300 ease-out'
										width='90'
										height='20'
										viewBox='0 0 62 30'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'>
										<path
											d='M1 18.3325C1 15.8161 3.03995 13.7761 5.55635 13.7761V13.7761C8.07275 13.7761 10.1127 15.8161 10.1127 18.3325V29.1538H1V18.3325Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='5.55614'
											cy='9.21972'
											r='3.98681'
											fill=''
											stroke=''
										/>
										<path
											d='M52.2822 18.3325C52.2822 15.8161 54.3222 13.7761 56.8386 13.7761V13.7761C59.355 13.7761 61.3949 15.8161 61.3949 18.3325V29.1538H52.2822V18.3325Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='56.8384'
											cy='9.21972'
											r='3.98681'
											fill=''
											stroke=''
										/>
										<path
											d='M12.9355 16.9658C12.9355 14.1699 15.2021 11.9033 17.998 11.9033V11.9033C20.7939 11.9033 23.0605 14.1699 23.0605 16.9658V28.9891H12.9355V16.9658Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='17.998'
											cy='6.84054'
											r='4.42965'
											fill=''
											stroke=''
										/>
										<path
											d='M39.335 16.9659C39.335 14.1699 41.6016 11.9033 44.3976 11.9033V11.9033C47.1936 11.9033 49.4602 14.1699 49.4602 16.9659V28.9896H39.335V16.9659Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='44.3976'
											cy='6.84067'
											r='4.42978'
											fill=''
											stroke=''
										/>
										<path
											d='M25.8818 16.2828C25.8818 13.347 28.2618 10.967 31.1976 10.967V10.967C34.1334 10.967 36.5133 13.347 36.5133 16.2828V28.9077H25.8818V16.2828Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='31.1972'
											cy='5.65127'
											r='4.65127'
											fill=''
											stroke=''
										/>
									</svg>
									{/* Mobile Icon  */}
									<svg
										className='fill-black flex  xl:hidden  transition-all duration-300 ease-out'
										width='60'
										height='20'
										viewBox='0 0 62 30'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'>
										<path
											d='M1 18.3325C1 15.8161 3.03995 13.7761 5.55635 13.7761V13.7761C8.07275 13.7761 10.1127 15.8161 10.1127 18.3325V29.1538H1V18.3325Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='5.55614'
											cy='9.21972'
											r='3.98681'
											fill=''
											stroke=''
										/>
										<path
											d='M52.2822 18.3325C52.2822 15.8161 54.3222 13.7761 56.8386 13.7761V13.7761C59.355 13.7761 61.3949 15.8161 61.3949 18.3325V29.1538H52.2822V18.3325Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='56.8384'
											cy='9.21972'
											r='3.98681'
											fill=''
											stroke=''
										/>
										<path
											d='M12.9355 16.9658C12.9355 14.1699 15.2021 11.9033 17.998 11.9033V11.9033C20.7939 11.9033 23.0605 14.1699 23.0605 16.9658V28.9891H12.9355V16.9658Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='17.998'
											cy='6.84054'
											r='4.42965'
											fill=''
											stroke=''
										/>
										<path
											d='M39.335 16.9659C39.335 14.1699 41.6016 11.9033 44.3976 11.9033V11.9033C47.1936 11.9033 49.4602 14.1699 49.4602 16.9659V28.9896H39.335V16.9659Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='44.3976'
											cy='6.84067'
											r='4.42978'
											fill=''
											stroke=''
										/>
										<path
											d='M25.8818 16.2828C25.8818 13.347 28.2618 10.967 31.1976 10.967V10.967C34.1334 10.967 36.5133 13.347 36.5133 16.2828V28.9077H25.8818V16.2828Z'
											fill=''
											stroke=''
										/>
										<circle
											cx='31.1972'
											cy='5.65127'
											r='4.65127'
											fill=''
											stroke=''
										/>
									</svg>
									Join as Lead Investor {'>'}
								</a>
							</div>
						</div>
					</div>
					<div className='xl:grid flex flex-col  col-span-4   w-full grid-cols-1   lg:grid-cols-3 gap-2'>
						<div className='col-span-3  items-start gap-0    h-full '>
							{/* <h1 className='text-black flex xl:hidden font-bold mt-10 mb-6   text-center  lg:text-start '>
								<span className='text-lime-500 mr-1'>
									The Amazon
								</span>{' '}
								of B2B Services
							</h1> */}
							<h1 className='text-lime-500 hidden xl:flex   font-bold      text-center mt-6 lg:-mb-4 lg:text-start text-5xl xl:text-7xl 2xl:text-8xl '>
								The Amazon of
							</h1>
							<h1 className='text-black  font-bold hidden xl:flex   text-center lg:mt-0 lg:mb-0 lg:text-start text-5xl xl:text-7xl 2xl:text-8xl '>
								B2B Services
							</h1>
						</div>
						<div className=' flex flex-col   h-full justify-start xl:-mt-14    rounded-lg  '>
							<div className='flex border rounded-[10px] gap-3 hover:scale-[1.009] hover:border-lime-500 transition-all duration-300 ease-in  flex-col w-full h-fit'>
								<a
									className='group     '
									href='https://salesmrkt.com/Pitch-Deck'
									target='_blank'
									rel='noopener noreferrer'>
									<div className='relative '>
										<img
											src={PitchDeck}
											alt=''
											className='w-full  shadow-sm rounded-md '
										/>
										<h2 className='text-black   leading-[0.9] text-[35px] md:text-[30px] lg:text-[32px] 2xl:text-[35px]  group-hover:text-lime-500 transition-all duration-300 ease-in font-semibold  absolute top-[20px] pl-4 max-w-[150px] '>
											Pitch Deck{' '}
											<span className=''>{'>'}</span>
										</h2>
									</div>
								</a>
								<div className='flex flex-row items-center justify-center mb-[12px] 2xl:gap-4 gap-2 h-[49px]'>
									<a
										className='group flex gap-2 2xl:gap-3   lg:max-w-[170px] items-center justify-center  font-bold    hover:scale-[1.02] transition-all duration-300 ease-in'
										href='https://docs.google.com/spreadsheets/d/11Uxd-z_79h9rRruxmOdoAS8UDsat6zE2/edit#gid=1698675998'
										target='_blank'
										rel='noopener noreferrer'>
										<h5 className=' flex items-end mt-3  group-hover:text-lime-500 transition-all duration-300 ease-in  leading-[1]  '>
											Financials{'>'}
										</h5>
										<div className='flex items-center justify-center'>
											<svg
												width='28'
												height='26'
												viewBox='0 0 28 26'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<line
													x1='1.87918'
													y1='23.835'
													x2='1.87918'
													y2='14.4279'
													stroke='#84CC16'
													stroke-width='2.70454'
													stroke-linecap='round'
												/>
												<line
													x1='7.93484'
													y1='23.835'
													x2='7.93484'
													y2='11.3999'
													stroke='#84CC16'
													stroke-width='2.70454'
													stroke-linecap='round'
												/>
												<line
													x1='13.9905'
													y1='23.835'
													x2='13.9905'
													y2='8.37203'
													stroke='#84CC16'
													stroke-width='2.70454'
													stroke-linecap='round'
												/>
												<line
													x1='20.0462'
													y1='23.835'
													x2='20.0462'
													y2='5.34411'
													stroke='#84CC16'
													stroke-width='2.70454'
													stroke-linecap='round'
												/>
												<line
													x1='26.1018'
													y1='23.835'
													x2='26.1018'
													y2='2.31619'
													stroke='#84CC16'
													stroke-width='2.70454'
													stroke-linecap='round'
												/>
											</svg>
										</div>
									</a>
									{/* <div className='w-[1px] h-[40px] bg-black/20  '></div> */}
									{/* <HashLink
										to={'/CapitalStack'}
										target='_blank'>
										<div className='group flex items-center gap-2   justify-center  font-bold    hover:scale-[1.02] transition-all duration-300 ease-in'>
											<h5 className=' group-hover:text-lime-500 mt-3  transition-all duration-300 ease-in  leading-[1]  '>
												Capstack
												<span className='ml-1'>
													{'>'}
												</span>
											</h5>
											<div>
												<img
													src={CapitalStack_Mini}
													alt=''
													className='w-[90%]'
												/>
											</div>
										</div>
									</HashLink> */}
								</div>
							</div>
						</div>
						<div className=' flex flex-col  xl:-mt-14 h-full justify-start   rounded-lg  '>
							<div className='flex border  hover:scale-[1.009]  hover:border-lime-500 transition-all duration-300 ease-in rounded-[10px] gap-3  flex-col w-full h-fit'>
								<div
									onClick={() =>
										setVideoOpenerExperience(true)
									}
									className='group cursor-pointer    '>
									<div className='relative '>
										<img
											src={MrktBeta}
											alt=''
											className='w-full  shadow-sm rounded-md '
										/>
										<h2 className='text-black leading-[0.9] text-[35px] md:text-[30px] lg:text-[32px] 2xl:text-[35px]   group-hover:text-lime-500 transition-all duration-300 ease-in font-semibold  absolute top-[20px] pl-3 '>
											B2B Meets <br></br> B2C{' '}
											<span className='pt-1'>{'>'}</span>
										</h2>
									</div>
								</div>
								<div className='grid grid-cols-1 mb-3 items-center justify-center '>
									<div
										onClick={() => setVideoOpenerDemo(true)}
										className='group flex  relative cursor-pointer    items-center justify-center  font-bold    hover:scale-[1.02] transition-all duration-300 ease-in'>
										<h5 className=' text-center flex items-center justify-center  group-hover:text-lime-500 pt-6 mb-[9px]   transition-all duration-300 ease-in  w-fit leading-[1]  '>
											Marketplace

											<span className='ml-1'>{'>'}</span>
										</h5>
										<video
											muted
											autoPlay
											loop
											playsInline
											disablePictureInPicture
											preload={'auto'}
											className='w-[50px] lg:w-[60px]  right-[40px]       '
											src={MultiMedia}></video>
									</div>
								</div>
							</div>
						</div>
						<div className=' flex flex-col xl:-mt-14 relative   h-full justify-start   rounded-lg  '>
							<a
								className='absolute hidden top-[-50px] lg:flex items-center justify-center font-semibold hover:text-lime-500 transition-all duration-300 right-0'
								href='https://www.shopify.com/news/hot-take-b2b-is-the-biggest-commerce-opportunity-of-2024'
								target='_blank'
								rel='noopener noreferrer'>
								Why 2024 is the Year of B2B Commerce {'>'}
							</a>
							<div className='flex hover:scale-[1.009] border transition-all  duration-300 ease-in relative rounded-[10px] gap-3  flex-col w-full h-fit'>
								<a
									className='group pointer-events-none'
									href='https://www.linkedin.com/in/joe-salesmrkt/'
									target='_blank'
									rel='noopener noreferrer'>
									<div className='relative'>
										<div className='w-full h-full flex items-center justify-center'>
											<a
												href='https://salesmrkt.com/'
												target='_blank'
												rel='noopener noreferrer'></a>
										</div>
										<img
											src={JoeLinkedIn}
											alt=''
											className='w-full  shadow-sm rounded-md '
										/>
										<div className='  '>
											{/* <h2 className='text-black leading-[0.9] text-[35px] md:text-[30px] lg:text-[32px] 2xl:text-[35px]  absolute top-[20px] pl-3     group-hover:text-lime-500 transition-all duration-300 ease-in font-semibold  '> */}
											<h2 className='text-black leading-[0.9] text-[35px] md:text-[30px] lg:text-[32px] 2xl:text-[35px]  absolute top-[20px] pl-3 transition-all duration-300 ease-in font-semibold  '>
												Founder{' '}
												{/* <svg
													className='inline-flex'
													width='25'
													height='25'
													viewBox='0 0 21 21'
													fill='none'
													xmlns='http://www.w3.org/2000/svg'>
													<path
														d='M16.0781 0H4.92188C2.2036 0 0 2.2036 0 4.92188V16.0781C0 18.7964 2.2036 21 4.92188 21H16.0781C18.7964 21 21 18.7964 21 16.0781V4.92188C21 2.2036 18.7964 0 16.0781 0Z'
														fill='#0076B2'
													/>
													<path
														d='M15.1524 17.857H17.5535C17.6405 17.857 17.7239 17.8224 17.7854 17.7609C17.847 17.6994 17.8816 17.6159 17.8816 17.5289L17.8828 12.456C17.8828 9.80446 17.3115 7.76639 14.2129 7.76639C13.035 7.72259 11.9242 8.32978 11.3248 9.34369C11.3219 9.34861 11.3174 9.35244 11.3121 9.35459C11.3068 9.35675 11.3009 9.3571 11.2954 9.3556C11.2899 9.35411 11.285 9.35084 11.2815 9.3463C11.278 9.34177 11.2761 9.33621 11.276 9.33048V8.3393C11.276 8.25227 11.2414 8.16881 11.1799 8.10728C11.1184 8.04574 11.0349 8.01117 10.9479 8.01117H8.66931C8.58228 8.01117 8.49883 8.04574 8.43729 8.10728C8.37575 8.16881 8.34118 8.25227 8.34118 8.3393V17.5284C8.34118 17.6155 8.37575 17.6989 8.43729 17.7605C8.49883 17.822 8.58228 17.8566 8.66931 17.8566H11.0702C11.1572 17.8566 11.2407 17.822 11.3022 17.7605C11.3638 17.6989 11.3983 17.6155 11.3983 17.5284V12.9861C11.3983 11.7018 11.642 10.4579 13.2343 10.4579C14.8039 10.4579 14.8243 11.9276 14.8243 13.0693V17.5288C14.8243 17.6159 14.8588 17.6993 14.9204 17.7609C14.9819 17.8224 15.0654 17.857 15.1524 17.857ZM3.11719 4.89128C3.11719 5.86458 3.91839 6.66537 4.89169 6.66537C5.86474 6.66528 6.66545 5.864 6.66545 4.89095C6.66529 3.91789 5.8645 3.11719 4.89136 3.11719C3.91798 3.11719 3.11719 3.91806 3.11719 4.89128ZM3.68804 17.857H6.09213C6.17916 17.857 6.26262 17.8224 6.32415 17.7609C6.38569 17.6993 6.42026 17.6159 6.42026 17.5288V8.3393C6.42026 8.25227 6.38569 8.16881 6.32415 8.10728C6.26262 8.04574 6.17916 8.01117 6.09213 8.01117H3.68804C3.60102 8.01117 3.51756 8.04574 3.45602 8.10728C3.39449 8.16881 3.35992 8.25227 3.35992 8.3393V17.5288C3.35992 17.6159 3.39449 17.6993 3.45602 17.7609C3.51756 17.8224 3.60102 17.857 3.68804 17.857Z'
														fill='white'
													/>
												</svg> */}
												<br></br> Profile{' '}
												<span className='ml-1'>
													{'>'}
												</span>
											</h2>
										</div>
									</div>
								</a>
								<div className='flex flex-row mb-3 mt-2 gap-2   items-center justify-center '>
									<div
										onClick={handleButtonClickCustomer}
										className='group cursor-pointer  flex items-center gap-2 justify-center   xl:justify-end  font-bold    hover:scale-[1.02] transition-all duration-300 ease-in'>
										<h5 className=' group-hover:text-lime-500 transition-all duration-300 ease-in w-fit leading-[1]  '>
											Clients
											<span className='ml-1'>{'>'}</span>
										</h5>
										<img
											src={Testimonials_Mini}
											alt=''
											className='w-[60px]   '
										/>
									</div>
									<a
										className='group flex gap-3 lg:gap-0 border-l border-black/20 lg:max-w-[170px] items-center justify-center  font-bold    hover:scale-[1.02] transition-all duration-300 ease-in'
										href='https://salesmrkt.com/orgchart'
										target='_blank'
										rel='noopener noreferrer'>
										<h5 className=' text-base group-hover:text-lime-500 transition-all mr-3 ml-3 duration-300 ease-in  leading-[1]  '>
											Org Chart
											<span className='ml-1'>{'>'}</span>
										</h5>
										<div>
											<svg
												className='transition-all dura ease'
												width='42'
												height='42'
												viewBox='0 0 42 42'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<g filter='url(#filter0_d_15767_406)'>
													<g filter='url(#filter1_d_15767_406)'>
														<path
															d='M13.0472 22.4894C12.8559 21.6432 12.1583 20.9537 11.2908 20.9537H2.8872C1.97918 20.9537 1.24156 21.7018 1.33396 22.6051C2.30614 32.1092 9.94402 39.7582 19.447 40.7183C20.3496 40.8095 21.0963 40.0722 21.0963 39.1651V30.7589C21.0963 29.8915 20.4069 29.1939 19.5609 29.0025C16.3246 28.2701 13.7804 25.7329 13.0472 22.4894Z'
															fill='#BCD537'
															fill-opacity='0.5'
														/>
														<path
															d='M12.8261 22.6382C12.635 21.7921 11.9373 21.1025 11.0698 21.1025H2.65381C1.74579 21.1025 1.00817 21.8506 1.10049 22.754C2.07301 32.2696 9.7203 39.928 19.2349 40.8885C20.1374 40.9796 20.8841 40.2423 20.8841 39.3352V30.9166C20.8841 30.0492 20.1948 29.3516 19.3487 29.1603C16.1077 28.4274 13.5597 25.8865 12.8261 22.6382Z'
															fill='#BCD537'
														/>
														<path
															d='M22.9518 28.9396C22.1055 29.1303 21.416 29.8279 21.416 30.6954V39.099C21.416 40.007 22.1641 40.7447 23.0675 40.6523C32.5715 39.6801 40.2205 32.0422 41.1807 22.5392C41.2719 21.6367 40.5346 20.8899 39.6274 20.8899H31.2215C30.354 20.8899 29.6564 21.5794 29.4657 22.4257C28.7344 25.6705 26.1966 28.2083 22.9518 28.9396Z'
															fill='#70C242'
															fill-opacity='0.5'
														/>
														<path
															d='M23.1637 29.1611C22.3174 29.3517 21.6279 30.0493 21.6279 30.9168V39.3328C21.6279 40.2409 22.3761 40.9785 23.2794 40.8862C32.795 39.9136 40.4534 32.2663 41.4139 22.7518C41.505 21.8492 40.7677 21.1025 39.8606 21.1025H31.4423C30.5748 21.1025 29.8771 21.792 29.6865 22.6383C28.9549 25.8879 26.4133 28.4294 23.1637 29.1611Z'
															fill='#70C242'
														/>
														<path
															d='M29.4648 19.036C29.6563 19.882 30.3539 20.5714 31.2213 20.5714H39.6274C40.5346 20.5714 41.2719 19.8247 41.1807 18.9222C40.2205 9.41915 32.5715 1.78127 23.0675 0.809091C22.1641 0.716691 21.416 1.45431 21.416 2.36233V10.7659C21.416 11.6334 22.1056 12.331 22.9517 12.5223C26.1952 13.2555 28.7324 15.7998 29.4648 19.036Z'
															fill='#BCD537'
															fill-opacity='0.5'
														/>
														<path
															d='M29.6767 18.8235C29.8682 19.6695 30.5658 20.3589 31.4332 20.3589H39.8394C40.7465 20.3589 41.4838 19.6122 41.3926 18.7097C40.4324 9.20666 32.7834 1.56877 23.2794 0.596597C22.3761 0.504197 21.6279 1.24182 21.6279 2.14984V10.5534C21.6279 11.4209 22.3175 12.1186 23.1636 12.3098C26.4072 13.043 28.9443 15.5873 29.6767 18.8235Z'
															fill='#BCD537'
														/>
														<path
															d='M19.561 12.5018C20.4069 12.3097 21.0963 11.6121 21.0963 10.7447V2.34091C21.0963 1.43289 20.3481 0.695262 19.4448 0.78768C9.94289 1.75984 2.30613 9.39659 1.33398 18.8985C1.24156 19.8019 1.97919 20.55 2.88721 20.55H11.291C12.1584 20.55 12.856 19.8606 13.0481 19.0147C13.7824 15.7796 16.3259 13.2361 19.561 12.5018Z'
															fill='#70C242'
															fill-opacity='0.5'
														/>
														<path
															d='M19.3491 12.3107C20.195 12.1187 20.8844 11.4211 20.8844 10.5537V2.14984C20.8844 1.24182 20.1362 0.504191 19.2329 0.59661C9.73097 1.56877 2.09422 9.20552 1.12206 18.7075C1.02964 19.6108 1.76727 20.3589 2.67529 20.3589H11.0791C11.9465 20.3589 12.6441 19.6695 12.8361 18.8236C13.5705 15.5886 16.114 13.045 19.3491 12.3107Z'
															fill='#70C242'
														/>
													</g>
													<path
														d='M18.503 20.855H14.8076C14.8759 24.2969 17.6889 27.1148 21.1308 27.1782V23.4828C19.7072 23.4194 18.5664 22.2835 18.503 20.855Z'
														fill='#BCD537'
													/>
													<path
														d='M21.3789 23.4828V27.1782C24.8208 27.1099 27.6387 24.2969 27.7021 20.855H24.0066C23.9433 22.2835 22.8073 23.4194 21.3789 23.4828Z'
														fill='#70C242'
													/>
													<path
														d='M24.0066 20.6064H27.7021C27.6387 17.1645 24.8208 14.3515 21.3789 14.2832V17.9786C22.8073 18.042 23.9433 19.1828 24.0066 20.6064Z'
														fill='#BCD537'
													/>
													<path
														d='M21.1308 17.9786V14.2832C17.6889 14.3515 14.8759 17.1645 14.8076 20.6064H18.503C18.5664 19.1828 19.7072 18.042 21.1308 17.9786Z'
														fill='#70C242'
													/>
													<path
														d='M21.2557 26.4347C24.4059 26.4347 26.9596 23.881 26.9596 20.7308C26.9596 17.5806 24.4059 15.0269 21.2557 15.0269C18.1055 15.0269 15.5518 17.5806 15.5518 20.7308C15.5518 23.881 18.1055 26.4347 21.2557 26.4347Z'
														fill='#EDEDED'
													/>
													<path
														d='M21.2557 26.4347C24.4059 26.4347 26.9596 23.881 26.9596 20.7308C26.9596 17.5806 24.4059 15.0269 21.2557 15.0269C18.1055 15.0269 15.5518 17.5806 15.5518 20.7308C15.5518 23.881 18.1055 26.4347 21.2557 26.4347Z'
														fill='white'
													/>
													<path
														d='M20.546 22.7075V22.9102H20.2124V23.9594H19.9613V22.9102H19.6277V22.7075H20.546ZM20.9804 22.9102V23.2241H21.4019V23.4232H20.9804V23.755H21.4557V23.9594H20.7293V22.7057H21.4557V22.9102H20.9804ZM22.4515 23.7209H21.9529L21.8704 23.9594H21.6067L22.0569 22.7057H22.3493L22.7995 23.9594H22.534L22.4515 23.7209ZM22.3834 23.52L22.2022 22.9963L22.0211 23.52H22.3834ZM21.8893 24.7075V25.9594H21.6382V25.1451L21.3027 25.9594H21.1126L20.7754 25.1451V25.9594H20.5243V24.7075H20.8095L21.2077 25.6384L21.6059 24.7075H21.8893Z'
														fill='black'
													/>
													<path
														d='M11.2252 12.6101C11.132 12.7295 11.0272 12.8215 10.9109 12.886C10.7959 12.9489 10.6783 12.9781 10.558 12.9737C10.4377 12.9692 10.3246 12.9269 10.2186 12.8468L10.5061 12.4788C10.5803 12.5289 10.655 12.5478 10.7304 12.5356C10.8071 12.5217 10.8761 12.4756 10.9374 12.3971C11 12.3169 11.0304 12.2393 11.0285 12.1641C11.0251 12.0876 10.9923 12.0251 10.9301 11.9766C10.8794 11.937 10.8256 11.9199 10.7686 11.9255C10.7116 11.931 10.6556 11.9504 10.6006 11.9838C10.5452 12.0142 10.4741 12.0614 10.3873 12.1253C10.2677 12.2109 10.1649 12.2768 10.0789 12.3228C9.99252 12.366 9.89764 12.388 9.79425 12.3888C9.69051 12.3868 9.58467 12.3436 9.47673 12.2593C9.37534 12.18 9.30683 12.0857 9.27122 11.9762C9.2356 11.8668 9.23394 11.7509 9.26624 11.6287C9.29691 11.5051 9.35824 11.3845 9.45024 11.2668C9.58823 11.0901 9.74336 10.9809 9.91564 10.9391C10.0876 10.8943 10.2549 10.9262 10.4175 11.0349L10.1224 11.4127C10.061 11.3699 9.9929 11.3576 9.91824 11.3756C9.84321 11.3908 9.77568 11.4367 9.71562 11.5136C9.66324 11.5807 9.63824 11.648 9.64064 11.7158C9.64432 11.7818 9.67887 11.8404 9.74428 11.8915C9.79007 11.9273 9.84 11.9426 9.89407 11.9375C9.94779 11.9294 10.0017 11.9109 10.0558 11.8821C10.1096 11.8504 10.1807 11.8032 10.2691 11.7406C10.3887 11.655 10.4923 11.5898 10.58 11.545C10.6676 11.5002 10.7639 11.478 10.869 11.4785C10.974 11.4789 11.0796 11.5206 11.1859 11.6037C11.2775 11.6752 11.344 11.7654 11.3855 11.8741C11.4269 11.9829 11.4356 12.1016 11.4115 12.2302C11.3857 12.3575 11.3236 12.4842 11.2252 12.6101Z'
														fill='#333333'
													/>
													<path
														d='M10.8234 11.6886C10.6929 11.5731 10.5998 11.4449 10.5443 11.3042C10.4901 11.1619 10.475 11.0224 10.4991 10.8857C10.5245 10.7475 10.5861 10.6232 10.6838 10.5129C10.7691 10.4166 10.8628 10.3499 10.965 10.3128C11.0685 10.2742 11.169 10.2593 11.2666 10.2681L11.0825 10.105L11.3735 9.77646L12.6645 10.92L12.3734 11.2485L12.1847 11.0813C12.2081 11.177 12.207 11.2799 12.1814 11.3903C12.1555 11.4977 12.0999 11.5996 12.0146 11.6959C11.9183 11.8046 11.8023 11.8793 11.6665 11.9198C11.5322 11.9589 11.3911 11.9601 11.2433 11.9234C11.0954 11.8839 10.9554 11.8056 10.8234 11.6886ZM11.728 10.6768C11.6487 10.6066 11.5674 10.5623 11.484 10.5438C11.399 10.524 11.3183 10.5274 11.242 10.5541C11.1641 10.5794 11.0984 10.6223 11.0447 10.6829C10.991 10.7435 10.9563 10.8125 10.9404 10.8899C10.9245 10.9673 10.9308 11.0478 10.9594 11.1313C10.9878 11.2119 11.0409 11.2866 11.1185 11.3554C11.1962 11.4242 11.2783 11.4692 11.3649 11.4905C11.4512 11.5087 11.5327 11.506 11.6092 11.4823C11.687 11.457 11.7521 11.4148 11.8044 11.3558C11.858 11.2952 11.8935 11.2254 11.9108 11.1465C11.9265 11.0661 11.9202 10.9856 11.8917 10.905C11.8618 10.823 11.8072 10.747 11.728 10.6768Z'
														fill='#333333'
													/>
													<path
														d='M11.1962 9.17289L12.8458 10.7809L12.5415 11.0929L10.892 9.48496L11.1962 9.17289Z'
														fill='#333333'
													/>
													<path
														d='M13.5502 8.87805C13.5927 8.92347 13.628 8.9672 13.656 9.00921L12.7362 9.8714C12.8289 9.95516 12.9274 9.99652 13.0317 9.99549C13.136 9.99446 13.229 9.95562 13.3107 9.87898C13.4289 9.76828 13.4653 9.63879 13.4202 9.49051L13.7632 9.16905C13.8404 9.32424 13.8644 9.48946 13.8352 9.6647C13.8047 9.83844 13.7144 9.99555 13.5645 10.1361C13.4434 10.2496 13.3095 10.3253 13.1629 10.3631C13.0165 10.398 12.8698 10.3918 12.7231 10.3445C12.5778 10.2957 12.4449 10.207 12.3243 10.0783C12.2022 9.94809 12.1215 9.80894 12.0823 9.66085C12.043 9.51275 12.0463 9.3675 12.092 9.22509C12.1377 9.08268 12.2226 8.95329 12.3468 8.83691C12.4664 8.72479 12.5973 8.65048 12.7394 8.61396C12.8831 8.57603 13.0253 8.58064 13.1662 8.62777C13.3072 8.67198 13.4352 8.7554 13.5502 8.87805ZM13.1357 9.09589C13.0575 9.01554 12.967 8.97811 12.864 8.98359C12.7596 8.98755 12.6658 9.02856 12.5825 9.10662C12.5038 9.18042 12.4599 9.26709 12.4508 9.36664C12.4418 9.46325 12.471 9.55963 12.5383 9.65578L13.1357 9.09589Z'
														fill='#333333'
													/>
													<path
														d='M14.5017 9.33138C14.3935 9.42193 14.2804 9.48407 14.1625 9.51778C14.0432 9.5499 13.9302 9.55384 13.8233 9.5296C13.718 9.50403 13.6291 9.45265 13.5564 9.37547L13.893 9.09382C13.942 9.13943 14.002 9.16097 14.0729 9.15844C14.1454 9.15457 14.2143 9.12534 14.2796 9.07074C14.3433 9.01748 14.3819 8.96346 14.3957 8.9087C14.411 8.8526 14.402 8.80466 14.3687 8.76486C14.3327 8.72189 14.2838 8.7087 14.2219 8.72529C14.1603 8.73896 14.0711 8.77302 13.9543 8.82745C13.8356 8.88614 13.7338 8.92939 13.6488 8.95719C13.5654 8.98365 13.4787 8.98993 13.3886 8.97603C13.3001 8.96079 13.2185 8.9086 13.144 8.81947C13.0827 8.74625 13.0475 8.66208 13.0382 8.56698C13.0306 8.47053 13.0511 8.37218 13.0998 8.27191C13.1501 8.17031 13.2286 8.07489 13.3352 7.98567C13.4928 7.85383 13.6519 7.78842 13.8123 7.78944C13.9715 7.78886 14.1118 7.85143 14.2332 7.97714L13.9133 8.24481C13.8646 8.19628 13.8076 8.17354 13.7426 8.17659C13.6777 8.17672 13.6127 8.20408 13.5474 8.25868C13.4869 8.30928 13.4493 8.35971 13.4345 8.40996C13.4213 8.45888 13.4314 8.50323 13.4647 8.54303C13.502 8.58759 13.5529 8.60317 13.6174 8.58976C13.6806 8.57476 13.7692 8.53991 13.8831 8.48521C13.9985 8.42919 14.098 8.38794 14.1813 8.36147C14.2647 8.335 14.3513 8.33018 14.4412 8.34701C14.5313 8.36092 14.6138 8.41098 14.6886 8.49719C14.7525 8.5736 14.7883 8.66002 14.7959 8.75646C14.8051 8.85157 14.7846 8.94992 14.7343 9.05152C14.6843 9.1502 14.6068 9.24349 14.5017 9.33138Z'
														fill='#333333'
													/>
													<path
														d='M27.0405 8.6645L27.6126 9.09513L27.4047 9.37118L26.4845 8.67843L27.7914 6.94252L28.1396 7.20464L27.0405 8.6645Z'
														fill='#333333'
													/>
													<path
														d='M29.1112 9.63368C29.0714 9.68163 29.0325 9.72214 28.9943 9.75521L28.0233 8.95107C27.9519 9.05359 27.9233 9.15651 27.9374 9.25983C27.9515 9.36315 28.0017 9.45055 28.0881 9.52203C28.2127 9.62528 28.3458 9.6452 28.4872 9.58179L28.8492 9.8816C28.705 9.9777 28.5441 10.0223 28.3666 10.0154C28.1904 10.0069 28.0232 9.93715 27.8649 9.8061C27.7371 9.7002 27.6451 9.57693 27.5892 9.43627C27.5361 9.29533 27.5239 9.14909 27.5524 8.99755C27.5825 8.84732 27.6538 8.70428 27.7663 8.56842C27.8801 8.43096 28.008 8.33345 28.15 8.27589C28.292 8.21832 28.4365 8.20327 28.5835 8.23072C28.7305 8.25817 28.8696 8.32616 29.0007 8.4347C29.1269 8.53928 29.2171 8.65977 29.2712 8.79618C29.3269 8.93392 29.3402 9.07564 29.3112 9.22134C29.285 9.36677 29.2184 9.50422 29.1112 9.63368ZM28.8429 9.24988C28.9128 9.16224 28.9386 9.0677 28.9202 8.96625C28.9031 8.86321 28.8506 8.77528 28.7627 8.70248C28.6796 8.63365 28.5881 8.60098 28.4882 8.60447C28.3912 8.60769 28.2993 8.64876 28.2124 8.72768L28.8429 9.24988Z'
														fill='#333333'
													/>
													<path
														d='M28.8277 9.44905C28.946 9.32104 29.0761 9.23075 29.218 9.17818C29.3613 9.12703 29.5011 9.11493 29.6373 9.14189C29.775 9.17026 29.8979 9.23446 30.0061 9.33448C30.1006 9.42182 30.1653 9.51694 30.2002 9.61984C30.2366 9.72415 30.2494 9.82498 30.2385 9.92234L30.4054 9.74175L30.7277 10.0397L29.5571 11.3061L29.2348 11.0081L29.4059 10.823C29.3098 10.8444 29.2069 10.8411 29.0971 10.8131C28.9903 10.785 28.8896 10.7272 28.7951 10.6399C28.6885 10.5413 28.6163 10.4237 28.5786 10.2871C28.5425 10.152 28.5443 10.0109 28.584 9.86395C28.6267 9.71688 28.7079 9.57858 28.8277 9.44905ZM29.8201 10.3749C29.8919 10.2972 29.938 10.2168 29.9582 10.1338C29.9799 10.0492 29.9782 9.96854 29.9531 9.89169C29.9295 9.81331 29.8879 9.74665 29.8285 9.69171C29.7691 9.63677 29.7008 9.60053 29.6238 9.583C29.5467 9.56547 29.4661 9.5701 29.382 9.5969C29.3008 9.62359 29.225 9.67503 29.1546 9.75123C29.0841 9.82742 29.0374 9.90856 29.0143 9.99465C28.9942 10.0806 28.9952 10.1621 29.0173 10.2391C29.0409 10.3174 29.0817 10.3834 29.1396 10.4369C29.1991 10.4919 29.2681 10.5288 29.3466 10.5477C29.4266 10.5652 29.5072 10.5605 29.5884 10.5338C29.671 10.5056 29.7482 10.4527 29.8201 10.3749Z'
														fill='#333333'
													/>
													<path
														d='M29.927 10.4775C30.0524 10.3564 30.1874 10.2736 30.332 10.2292C30.4781 10.1862 30.619 10.1828 30.7549 10.219C30.8907 10.2551 31.0099 10.3262 31.1122 10.4322C31.19 10.5128 31.2464 10.607 31.2812 10.7147C31.3175 10.8211 31.3274 10.924 31.311 11.0235L31.9 10.4548L32.207 10.7728L30.5498 12.3729L30.2428 12.0549L30.4264 11.8776C30.3277 11.8979 30.2258 11.8909 30.1207 11.8568C30.0157 11.8227 29.9184 11.7593 29.8291 11.6668C29.7282 11.5623 29.6628 11.4408 29.6329 11.3023C29.6031 11.1638 29.6121 11.0223 29.6602 10.8779C29.7111 10.7334 29.8001 10.6 29.927 10.4775ZM30.8652 11.4582C30.9414 11.3847 30.9919 11.307 31.0168 11.2253C31.0432 11.1421 31.0461 11.0614 31.0255 10.9833C31.0063 10.9037 30.9686 10.8348 30.9124 10.7765C30.8562 10.7183 30.7901 10.6783 30.7142 10.6564C30.6383 10.6345 30.5575 10.6345 30.472 10.6565C30.3894 10.6786 30.3108 10.7256 30.2362 10.7977C30.1615 10.8698 30.1103 10.9481 30.0824 11.0328C30.0574 11.1175 30.0538 11.1988 30.0715 11.2769C30.0906 11.3565 30.1276 11.4247 30.1824 11.4814C30.2386 11.5397 30.3054 11.5805 30.3828 11.6038C30.4616 11.6258 30.5424 11.6257 30.6249 11.6037C30.709 11.5802 30.7891 11.5317 30.8652 11.4582Z'
														fill='#333333'
													/>
													<path
														d='M32.9226 12.8961C32.962 12.7999 32.9727 12.7029 32.9547 12.6051C32.9367 12.5074 32.891 12.4135 32.8176 12.3233C32.7364 12.2236 32.6418 12.1534 32.5338 12.1128C32.4259 12.0723 32.3124 12.0643 32.1933 12.089C32.0742 12.1137 31.96 12.1705 31.8505 12.2596C31.7379 12.3513 31.6574 12.453 31.6091 12.5646C31.5621 12.6778 31.5481 12.7921 31.5673 12.9077C31.5864 13.0232 31.6385 13.1333 31.7237 13.2379C31.8285 13.3667 31.9481 13.4446 32.0826 13.4717C32.2186 13.4974 32.3582 13.4734 32.5015 13.3995L32.0298 12.8201L32.2882 12.6098L33.031 13.5224L32.7365 13.7622C32.6007 13.8353 32.4527 13.8754 32.2927 13.8826C32.1326 13.8898 31.9742 13.8596 31.8174 13.7919C31.6635 13.7245 31.5276 13.6183 31.4097 13.4735C31.2774 13.3109 31.1937 13.1342 31.1587 12.9433C31.1266 12.7526 31.1449 12.5664 31.2137 12.3847C31.2838 12.2045 31.4018 12.0469 31.5675 11.912C31.7333 11.777 31.9115 11.6935 32.1021 11.6614C32.2957 11.6296 32.4817 11.6494 32.6603 11.7209C32.8418 11.7926 32.998 11.9089 33.129 12.0698C33.2836 12.2597 33.3713 12.4627 33.3919 12.6787C33.4141 12.8934 33.3632 13.0955 33.2391 13.2848L32.9226 12.8961Z'
														fill='#333333'
													/>
													<path
														d='M33.4821 14.7425C33.4316 14.779 33.3838 14.8084 33.3385 14.8308L32.6005 13.8086C32.5056 13.8899 32.4521 13.9823 32.4398 14.0859C32.4275 14.1895 32.4542 14.2867 32.5198 14.3775C32.6146 14.5088 32.7384 14.5615 32.8912 14.5356L33.1663 14.9167C33.0026 14.9735 32.8356 14.9763 32.6655 14.925C32.4971 14.8726 32.3528 14.7631 32.2325 14.5965C32.1353 14.4619 32.0773 14.3195 32.0584 14.1693C32.0425 14.0195 32.0673 13.8749 32.133 13.7354C32.1998 13.5975 32.3048 13.4769 32.4478 13.3737C32.5925 13.2692 32.7408 13.2069 32.8927 13.1869C33.0446 13.1668 33.1882 13.1885 33.3236 13.252C33.4591 13.3155 33.5766 13.4162 33.6762 13.5542C33.7722 13.6871 33.8292 13.8264 33.8473 13.972C33.8666 14.1193 33.8439 14.2599 33.7792 14.3936C33.7174 14.5278 33.6184 14.6441 33.4821 14.7425ZM33.3188 14.3036C33.4085 14.2364 33.4571 14.1513 33.4648 14.0485C33.4742 13.9445 33.4455 13.8462 33.3787 13.7537C33.3155 13.6662 33.2351 13.6116 33.1375 13.5899C33.0429 13.5686 32.9435 13.5853 32.8396 13.6399L33.3188 14.3036Z'
														fill='#333333'
													/>
													<path
														d='M34.5721 14.9153C34.6832 15.0881 34.718 15.2631 34.6765 15.4403C34.6367 15.6164 34.5191 15.7673 34.3236 15.893L33.4726 16.4402L33.2369 16.0736L34.0381 15.5584C34.1533 15.4843 34.223 15.3989 34.247 15.302C34.2728 15.204 34.2538 15.1052 34.1898 15.0057C34.1247 14.9044 34.0416 14.8444 33.9406 14.8254C33.8425 14.8071 33.7358 14.835 33.6206 14.909L32.8194 15.4242L32.5837 15.0576L34.0343 14.1249L34.27 14.4915L34.0893 14.6077C34.1836 14.6162 34.2723 14.6467 34.3555 14.6993C34.4415 14.7525 34.5137 14.8245 34.5721 14.9153Z'
														fill='#333333'
													/>
													<path
														d='M27.5634 36.6175C27.4502 36.4361 27.3896 36.2489 27.3816 36.0558C27.3742 35.8598 27.4162 35.6782 27.5076 35.5111C27.5996 35.3411 27.7336 35.2011 27.9097 35.0912C28.1156 34.9626 28.329 34.9028 28.5499 34.9117C28.7707 34.9206 28.9702 34.9991 29.1483 35.1473L28.7232 35.4127C28.626 35.351 28.5249 35.3224 28.42 35.3267C28.3168 35.33 28.2151 35.3629 28.1147 35.4256C28.0074 35.4926 27.9274 35.578 27.8747 35.6818C27.8228 35.7828 27.8016 35.8939 27.8112 36.0151C27.8226 36.1352 27.8667 36.2568 27.9437 36.3801C28.0195 36.5015 28.1094 36.5946 28.2134 36.6594C28.3181 36.7212 28.4278 36.7519 28.5424 36.7513C28.6576 36.7478 28.769 36.7125 28.8764 36.6455C28.9767 36.5829 29.051 36.5059 29.0992 36.4146C29.1481 36.3205 29.1662 36.2162 29.1535 36.1019L29.5786 35.8364C29.6346 36.0633 29.6181 36.2778 29.5291 36.4802C29.4408 36.6797 29.2928 36.8442 29.0851 36.9739C28.909 37.0838 28.725 37.1437 28.5329 37.1535C28.3416 37.1604 28.16 37.1184 27.9882 37.0275C27.8182 36.9355 27.6766 36.7988 27.5634 36.6175Z'
														fill='#333333'
													/>
													<path
														d='M29.2091 35.8294C29.107 35.6881 29.0442 35.5427 29.0208 35.3933C28.999 35.2426 29.0147 35.1032 29.0681 34.9751C29.1231 34.8457 29.2103 34.7379 29.3298 34.6516C29.4341 34.5762 29.5401 34.5316 29.6479 34.5178C29.7573 34.5027 29.8587 34.5102 29.952 34.54L29.8079 34.3407L30.1637 34.0837L31.1736 35.4816L30.8179 35.7386L30.6702 35.5342C30.6722 35.6326 30.6486 35.7329 30.5994 35.8349C30.5508 35.9341 30.4743 36.0214 30.37 36.0967C30.2522 36.1818 30.1227 36.2293 29.9814 36.2392C29.8417 36.2479 29.7038 36.2183 29.5676 36.1503C29.4319 36.0793 29.3124 35.9724 29.2091 35.8294ZM30.3129 35.0397C30.2509 34.9539 30.1812 34.8928 30.1038 34.8566C30.0252 34.8187 29.9458 34.8044 29.8655 34.8137C29.784 34.8214 29.7104 34.8489 29.6448 34.8963C29.5792 34.9437 29.5302 35.0035 29.4978 35.0755C29.4654 35.1476 29.454 35.2275 29.4636 35.3153C29.4737 35.4001 29.5092 35.4846 29.5699 35.5687C29.6307 35.6528 29.701 35.7147 29.7808 35.7543C29.8611 35.791 29.9412 35.8062 30.021 35.7997C30.1025 35.792 30.1752 35.7651 30.2391 35.7189C30.3047 35.6715 30.3546 35.6112 30.3887 35.5379C30.4216 35.4629 30.433 35.383 30.4229 35.2982C30.4115 35.2116 30.3749 35.1254 30.3129 35.0397Z'
														fill='#333333'
													/>
													<path
														d='M31.6848 32.7355C31.846 32.5983 32.018 32.5379 32.2007 32.5541C32.3836 32.5674 32.5504 32.6626 32.701 32.8396L33.3565 33.6102L33.0245 33.8926L32.4074 33.167C32.32 33.0643 32.2273 33.0082 32.1294 32.9988C32.0302 32.9879 31.9356 33.0207 31.8455 33.0974C31.7554 33.174 31.707 33.2629 31.7003 33.3639C31.6938 33.462 31.7343 33.5625 31.8217 33.6652L32.4389 34.3908L32.1069 34.6731L31.4898 33.9476C31.4024 33.8448 31.3097 33.7888 31.2118 33.7794C31.1126 33.7684 31.0179 33.8013 30.9278 33.8779C30.8362 33.9559 30.787 34.0454 30.7803 34.1465C30.7738 34.2446 30.8143 34.345 30.9017 34.4478L31.5189 35.1733L31.1869 35.4557L30.0696 34.1421L30.4015 33.8597L30.5367 34.0186C30.5323 33.927 30.5498 33.8371 30.5893 33.749C30.6304 33.6596 30.6913 33.5806 30.7719 33.512C30.8746 33.4246 30.9851 33.3687 31.1034 33.3444C31.2203 33.3185 31.3352 33.3271 31.448 33.37C31.4262 33.2579 31.4361 33.1446 31.4777 33.0302C31.5209 32.9144 31.5899 32.8162 31.6848 32.7355Z'
														fill='#333333'
													/>
													<path
														d='M32.3078 32.4674C32.2918 32.372 32.3 32.2714 32.3324 32.1658C32.3649 32.0573 32.4259 31.9583 32.5155 31.8689C32.6198 31.7649 32.7395 31.6968 32.8746 31.6647C33.0111 31.6311 33.1512 31.6379 33.295 31.6851C33.4387 31.7293 33.5729 31.8138 33.6974 31.9387C33.822 32.0636 33.9077 32.1995 33.9544 32.3463C34.0012 32.4901 34.0084 32.631 33.9759 32.7689C33.9449 32.9053 33.8772 33.0256 33.7729 33.1296C33.6833 33.219 33.5856 33.2798 33.4799 33.3119C33.3757 33.3426 33.2744 33.3513 33.1761 33.338L33.9301 34.0939L33.6216 34.4017L31.8234 32.5988L32.132 32.291L32.3078 32.4674ZM33.3823 32.2531C33.309 32.1796 33.2305 32.1318 33.1469 32.1097C33.0633 32.0846 32.9826 32.083 32.9048 32.105C32.8285 32.1254 32.7617 32.1642 32.7044 32.2214C32.6485 32.277 32.6103 32.3445 32.5896 32.4237C32.569 32.5 32.5703 32.5807 32.5937 32.6658C32.6185 32.7495 32.6676 32.8281 32.7409 32.9016C32.8141 32.975 32.8926 33.0243 32.9762 33.0493C33.0613 33.0729 33.1427 33.0752 33.2205 33.0563C33.2983 33.0344 33.3651 32.9956 33.421 32.9399C33.4783 32.8827 33.5165 32.8153 33.5357 32.7375C33.5564 32.6583 33.5543 32.5769 33.5294 32.4932C33.5061 32.408 33.457 32.328 33.3823 32.2531Z'
														fill='#333333'
													/>
													<path
														d='M33.4891 32.1272C33.3584 32.0118 33.2652 31.8839 33.2093 31.7432C33.1549 31.6011 33.1396 31.4616 33.1634 31.3249C33.1886 31.1866 33.2499 31.0622 33.3474 30.9517C33.4325 30.8552 33.5261 30.7884 33.6282 30.7511C33.7317 30.7123 33.8322 30.6972 33.9297 30.7059L33.7454 30.5431L34.0358 30.214L35.3288 31.3552L35.0384 31.6843L34.8493 31.5174C34.8729 31.613 34.872 31.716 34.8465 31.8263C34.8209 31.9338 34.7655 32.0358 34.6804 32.1322C34.5842 32.2412 34.4683 32.316 34.3327 32.3568C34.1984 32.3961 34.0573 32.3975 33.9095 32.3612C33.7615 32.3219 33.6214 32.2439 33.4891 32.1272ZM34.3919 31.1137C34.3125 31.0437 34.2311 30.9995 34.1476 30.9812C34.0626 30.9615 33.9819 30.965 33.9057 30.9919C33.8279 31.0173 33.7622 31.0604 33.7086 31.121C33.6551 31.1817 33.6204 31.2508 33.6047 31.3282C33.5889 31.4057 33.5954 31.4861 33.6241 31.5696C33.6527 31.6502 33.7059 31.7248 33.7837 31.7934C33.8615 31.8621 33.9437 31.9069 34.0303 31.928C34.1167 31.9461 34.1981 31.9433 34.2745 31.9194C34.3523 31.8939 34.4173 31.8517 34.4695 31.7925C34.5231 31.7318 34.5584 31.662 34.5755 31.583C34.5911 31.5027 34.5846 31.4222 34.556 31.3416C34.5259 31.2597 34.4712 31.1837 34.3919 31.1137Z'
														fill='#333333'
													/>
													<path
														d='M33.9184 29.985C33.8703 30.0448 33.8114 30.0801 33.7417 30.0907C33.6717 30.0983 33.6084 30.0794 33.5517 30.034C33.4951 29.9885 33.4638 29.9314 33.4577 29.8627C33.4513 29.7911 33.4722 29.7253 33.5202 29.6654C33.5683 29.6055 33.6274 29.5718 33.6974 29.5641C33.7671 29.5535 33.8302 29.5709 33.8869 29.6164C33.9435 29.6619 33.975 29.7204 33.9814 29.7921C33.9875 29.8608 33.9664 29.9251 33.9184 29.985ZM34.2131 29.9461L35.558 31.0255L35.2852 31.3654L33.9403 30.2859L34.2131 29.9461Z'
														fill='#333333'
													/>
													<path
														d='M34.7753 29.1444C34.8511 29.0404 34.9387 28.9642 35.038 28.9159C35.1357 28.8664 35.2338 28.8428 35.3322 28.8452L35.1334 28.7004L35.3918 28.3456L36.7958 29.3684C36.925 29.4625 37.0209 29.5722 37.0837 29.6975C37.1481 29.824 37.1718 29.9607 37.1548 30.1074C37.1394 30.2554 37.0779 30.4032 36.9704 30.5508C36.8262 30.7488 36.6616 30.8779 36.4764 30.9381C36.2925 30.9967 36.1148 30.9764 35.9432 30.8771L36.198 30.5273C36.2752 30.5553 36.3542 30.5526 36.4351 30.5191C36.5189 30.4851 36.5926 30.4245 36.6561 30.3373C36.7307 30.235 36.7601 30.1293 36.7445 30.0204C36.7305 29.9127 36.6615 29.8136 36.5374 29.7232L36.321 29.5655C36.3534 29.6585 36.3621 29.7611 36.3471 29.8734C36.3332 29.984 36.2891 30.0904 36.2145 30.1928C36.129 30.3102 36.0206 30.3955 35.8893 30.4488C35.7581 30.5021 35.6172 30.5176 35.4666 30.4952C35.3156 30.4699 35.1688 30.4053 35.0262 30.3015C34.8853 30.1988 34.7805 30.0801 34.7118 29.9453C34.6443 29.8089 34.616 29.6715 34.627 29.5331C34.6391 29.393 34.6886 29.2634 34.7753 29.1444ZM35.8303 29.2081C35.7448 29.1458 35.6596 29.1094 35.5748 29.099C35.4883 29.0873 35.4083 29.0984 35.3349 29.1322C35.2598 29.1648 35.1984 29.2138 35.1508 29.2792C35.1031 29.3446 35.0751 29.4166 35.0666 29.4952C35.0582 29.5738 35.0722 29.6533 35.1086 29.7337C35.1445 29.8112 35.2044 29.8806 35.2883 29.9417C35.3721 30.0028 35.4582 30.0397 35.5464 30.0526C35.6341 30.0626 35.7149 30.0522 35.7887 30.0212C35.8638 29.9886 35.9246 29.9405 35.971 29.8767C36.0187 29.8113 36.0473 29.7385 36.057 29.6582C36.065 29.5768 36.051 29.4973 36.0151 29.4197C35.9775 29.341 35.9159 29.2704 35.8303 29.2081Z'
														fill='#333333'
													/>
													<path
														d='M35.8006 27.607C35.9108 27.4336 36.0551 27.3286 36.2334 27.292C36.4099 27.2542 36.5962 27.2978 36.7923 27.4225L37.6459 27.9655L37.412 28.3332L36.6083 27.822C36.4927 27.7484 36.3859 27.7211 36.2879 27.7399C36.1881 27.7576 36.1064 27.8163 36.0429 27.9161C35.9783 28.0177 35.9586 28.1183 35.9838 28.2179C36.0083 28.3147 36.0783 28.3998 36.1939 28.4733L36.9976 28.9846L36.7637 29.3523L35.3086 28.4267L35.5425 28.0589L35.7238 28.1742C35.6919 28.0851 35.6824 27.9918 35.6953 27.8942C35.7076 27.7938 35.7426 27.698 35.8006 27.607Z'
														fill='#333333'
													/>
													<path
														d='M37.9685 27.3971C37.8997 27.5203 37.8162 27.6187 37.7181 27.6922C37.6181 27.7648 37.5139 27.8088 37.4054 27.8242C37.298 27.8379 37.1965 27.8216 37.1011 27.7754L37.3151 27.3923C37.3772 27.4174 37.4409 27.4161 37.5062 27.3885C37.5726 27.359 37.6266 27.3071 37.668 27.2328C37.7085 27.1604 37.7254 27.0961 37.7187 27.0401C37.713 26.9822 37.6875 26.9406 37.6422 26.9153C37.5933 26.888 37.5429 26.8931 37.491 26.9307C37.4383 26.9654 37.3671 27.0291 37.2774 27.1216C37.1874 27.2187 37.1077 27.2954 37.0383 27.3517C36.9698 27.4062 36.891 27.443 36.8019 27.4621C36.7138 27.4794 36.619 27.4598 36.5175 27.4031C36.4342 27.3565 36.3712 27.2905 36.3287 27.2049C36.2872 27.1175 36.2713 27.0183 36.281 26.9073C36.2918 26.7944 36.331 26.6773 36.3989 26.5559C36.4991 26.3766 36.6243 26.2587 36.7746 26.2024C36.9231 26.1451 37.0765 26.1536 37.2347 26.2277L37.0313 26.5919C36.9685 26.5639 36.9072 26.563 36.8475 26.589C36.7869 26.6123 36.7359 26.661 36.6944 26.7353C36.656 26.8041 36.6388 26.8647 36.6429 26.9169C36.648 26.9673 36.6732 27.0052 36.7185 27.0305C36.7693 27.0588 36.8224 27.0552 36.8779 27.0196C36.9316 26.9831 37.0019 26.9189 37.0888 26.8272C37.1767 26.7337 37.2549 26.6597 37.3233 26.6053C37.3918 26.5508 37.471 26.5154 37.5609 26.4991C37.6501 26.4799 37.745 26.4973 37.8456 26.5512C37.9326 26.5997 37.9968 26.6677 38.0383 26.7551C38.0809 26.8407 38.0968 26.9399 38.086 27.0527C38.0745 27.1627 38.0353 27.2775 37.9685 27.3971Z'
														fill='#333333'
													/>
													<path
														d='M6.93517 27.4468L6.48117 27.7478L6.88545 28.3575L6.59749 28.5484L6.19321 27.9388L5.71327 28.257L6.16916 28.9445L5.87341 29.1406L5.17667 28.09L6.99007 26.8874L7.68681 27.9381L7.39106 28.1342L6.93517 27.4468Z'
														fill='#333333'
													/>
													<path
														d='M6.48988 29.9787L6.71646 29.3776L6.09831 29.4359L5.82511 29.0572L6.85656 29.0078L7.22 28.0432L7.50777 28.4421L7.2819 29.0388L7.89934 28.9848L8.17254 29.3635L7.14432 29.4067L6.77765 30.3775L6.48988 29.9787Z'
														fill='#333333'
													/>
													<path
														d='M8.16311 29.7262C8.25972 29.7213 8.35862 29.741 8.4598 29.7853C8.5639 29.83 8.6552 29.902 8.73369 30.0013C8.82506 30.1169 8.87892 30.2436 8.89529 30.3815C8.91295 30.5209 8.89009 30.6593 8.82673 30.7967C8.76629 30.9344 8.66687 31.058 8.52849 31.1674C8.3901 31.2767 8.2453 31.3462 8.0941 31.3758C7.94581 31.4057 7.80504 31.3966 7.67179 31.3485C7.53983 31.302 7.42817 31.221 7.3368 31.1054C7.2583 31.0061 7.20917 30.9021 7.18939 30.7934C7.17089 30.6863 7.17392 30.5848 7.19847 30.4886L6.36082 31.1507L6.09059 30.8088L8.08824 29.2299L8.35848 29.5718L8.16311 29.7262ZM8.25246 30.8181C8.33386 30.7538 8.39036 30.6814 8.42195 30.6008C8.45645 30.5207 8.46729 30.4407 8.45447 30.3609C8.44294 30.2827 8.41208 30.2119 8.36189 30.1484C8.31299 30.0865 8.25039 30.0408 8.17407 30.0111C8.10067 29.9819 8.02034 29.9739 7.93308 29.9874C7.8471 30.0024 7.76341 30.0421 7.68201 30.1065C7.60061 30.1708 7.54265 30.2431 7.50815 30.3232C7.47494 30.405 7.46328 30.4857 7.47318 30.5651C7.486 30.6449 7.51686 30.7158 7.56576 30.7776C7.61595 30.8411 7.67856 30.8869 7.75358 30.9149C7.8299 30.9445 7.91104 30.9518 7.99702 30.9367C8.08428 30.9233 8.16943 30.8838 8.25246 30.8181Z'
														fill='#333333'
													/>
													<path
														d='M9.50086 32.2014C9.45386 32.2422 9.40883 32.2758 9.36579 32.3022L8.53906 31.3504C8.45186 31.4399 8.4068 31.5368 8.40389 31.641C8.40097 31.7452 8.43626 31.8397 8.50974 31.9243C8.61589 32.0465 8.7439 32.0878 8.89378 32.0483L9.20202 32.4032C9.04402 32.4745 8.87802 32.4922 8.70401 32.4565C8.53157 32.4193 8.37798 32.3232 8.24326 32.1681C8.13439 32.0428 8.06382 31.9061 8.03156 31.7582C8.00223 31.6105 8.01399 31.4643 8.06683 31.3194C8.12104 31.1761 8.21473 31.0466 8.3479 30.931C8.48264 30.8139 8.62474 30.7386 8.77421 30.705C8.92368 30.6714 9.06869 30.6801 9.20926 30.7312C9.34983 30.7822 9.47592 30.872 9.58751 31.0005C9.69502 31.1242 9.76432 31.2578 9.79543 31.4012C9.82789 31.5462 9.81791 31.6882 9.76548 31.8272C9.71597 31.9664 9.62776 32.0911 9.50086 32.2014ZM9.29887 31.7789C9.38212 31.7039 9.42295 31.6148 9.42137 31.5117C9.42136 31.4073 9.38393 31.312 9.30908 31.2258C9.23832 31.1443 9.15337 31.0972 9.05424 31.0843C8.95805 31.0717 8.86063 31.0972 8.76201 31.1609L9.29887 31.7789Z'
														fill='#333333'
													/>
													<path
														d='M10.1295 32.0274C10.2345 32.0059 10.3364 32.0099 10.4353 32.0396C10.5356 32.0708 10.6254 32.1288 10.7049 32.2136L10.3709 32.5264L10.2921 32.4423C10.1985 32.3424 10.1041 32.2886 10.0089 32.2811C9.91516 32.2751 9.80996 32.3267 9.69333 32.4359L9.06626 33.0232L8.76836 32.7052L10.027 31.5263L10.3249 31.8444L10.1295 32.0274Z'
														fill='#333333'
													/>
													<path
														d='M11.0123 32.2562C10.9584 32.2016 10.9301 32.139 10.9276 32.0686C10.9281 31.9981 10.9541 31.9374 11.0058 31.8864C11.0574 31.8353 11.1178 31.8107 11.1867 31.8126C11.2586 31.8145 11.3215 31.8428 11.3755 31.8974C11.4295 31.952 11.4562 32.0146 11.4558 32.085C11.4583 32.1555 11.4337 32.2162 11.382 32.2673C11.3304 32.3183 11.2686 32.3429 11.1967 32.341C11.1277 32.3391 11.0663 32.3108 11.0123 32.2562ZM11.0171 32.5534L9.79025 33.7653L9.48399 33.4553L10.7108 32.2433L11.0171 32.5534Z'
														fill='#333333'
													/>
													<path
														d='M11.8294 34.4661C11.7866 34.5113 11.7451 34.5491 11.7048 34.5796L10.7893 33.7129C10.7112 33.8105 10.6758 33.9113 10.6831 34.0153C10.6903 34.1193 10.7346 34.2098 10.816 34.2869C10.9336 34.3982 11.065 34.4269 11.2103 34.373L11.5517 34.6961C11.4014 34.7824 11.2379 34.8163 11.0612 34.7976C10.886 34.7775 10.7238 34.6968 10.5746 34.5555C10.454 34.4414 10.3704 34.3123 10.3239 34.1683C10.2803 34.0241 10.2778 33.8774 10.3163 33.7281C10.3562 33.5802 10.4369 33.4422 10.5581 33.3141C10.6808 33.1845 10.8149 33.0957 10.9604 33.0476C11.1059 32.9996 11.2511 32.9942 11.3959 33.0313C11.5408 33.0684 11.675 33.1455 11.7986 33.2625C11.9177 33.3752 11.9997 33.5014 12.0446 33.6411C12.091 33.7822 12.0949 33.9245 12.0563 34.0679C12.0206 34.2113 11.945 34.344 11.8294 34.4661ZM11.5872 34.0654C11.6628 33.9826 11.6947 33.8899 11.6831 33.7875C11.6729 33.6835 11.6264 33.5923 11.5435 33.5139C11.4651 33.4397 11.376 33.401 11.2761 33.3979C11.1791 33.3947 11.0846 33.4296 10.9927 33.5026L11.5872 34.0654Z'
														fill='#333333'
													/>
													<path
														d='M13.0276 34.3513C13.1831 34.4856 13.2661 34.6435 13.2765 34.8252C13.2882 35.0053 13.2181 35.1834 13.0663 35.3593L12.4052 36.1251L12.0753 35.8403L12.6977 35.1193C12.7872 35.0156 12.8298 34.9139 12.8254 34.8142C12.8224 34.7129 12.7761 34.6236 12.6866 34.5463C12.5955 34.4676 12.4988 34.4335 12.3966 34.444C12.2973 34.4542 12.2029 34.5111 12.1134 34.6148L11.4909 35.3358L11.161 35.0511L12.288 33.7457L12.6178 34.0305L12.4775 34.193C12.5703 34.1745 12.664 34.1786 12.7587 34.2055C12.8563 34.2322 12.9459 34.2808 13.0276 34.3513Z'
														fill='#333333'
													/>
													<path
														d='M12.8374 35.3462C12.9478 35.2059 13.0726 35.1061 13.2118 35.0466C13.3523 34.9856 13.4955 34.9663 13.6416 34.9888C13.7889 35.0097 13.9278 35.0714 14.0582 35.1741C14.2262 35.3063 14.3314 35.4578 14.374 35.6286C14.4194 35.799 14.4012 35.9748 14.3193 36.156L13.95 35.8653C13.9766 35.7912 13.9791 35.7192 13.9575 35.6494C13.9388 35.5792 13.8952 35.5172 13.8267 35.4633C13.7288 35.3863 13.6231 35.3612 13.5096 35.388C13.3973 35.4132 13.2899 35.491 13.1872 35.6215C13.0858 35.7503 13.0354 35.8731 13.036 35.9897C13.0379 36.1048 13.0877 36.2008 13.1856 36.2778C13.3242 36.3869 13.4635 36.3962 13.6034 36.3056L13.9728 36.5963C13.8198 36.7136 13.6538 36.7718 13.4749 36.7709C13.296 36.7701 13.1233 36.7042 12.957 36.5733C12.8266 36.4706 12.7332 36.3509 12.677 36.2143C12.6221 36.076 12.6072 35.9322 12.6323 35.7829C12.6586 35.632 12.727 35.4864 12.8374 35.3462Z'
														fill='#333333'
													/>
													<path
														d='M15.3952 37.2038C15.3589 37.2543 15.3228 37.2974 15.287 37.333L14.2631 36.5975C14.1989 36.7047 14.1774 36.8093 14.1986 36.9114C14.2198 37.0135 14.2759 37.0973 14.3669 37.1627C14.4984 37.2571 14.6325 37.2678 14.7692 37.1949L15.151 37.4691C15.0137 37.5749 14.8562 37.6304 14.6786 37.6357C14.5023 37.6394 14.3307 37.5812 14.1638 37.4614C14.029 37.3645 13.9288 37.2479 13.8633 37.1114C13.8007 36.9744 13.7784 36.8294 13.7965 36.6762C13.8162 36.5243 13.8775 36.3767 13.9804 36.2335C14.0845 36.0885 14.2054 35.9824 14.3431 35.9153C14.4808 35.8481 14.6239 35.8231 14.7725 35.8404C14.921 35.8577 15.0644 35.916 15.2026 36.0153C15.3358 36.1109 15.434 36.2249 15.4973 36.3573C15.5624 36.4909 15.5854 36.6313 15.5664 36.7787C15.5503 36.9256 15.4933 37.0672 15.3952 37.2038ZM15.1013 36.8393C15.1649 36.7471 15.1841 36.651 15.1588 36.5511C15.1347 36.4494 15.0763 36.3653 14.9836 36.2987C14.896 36.2358 14.8025 36.2095 14.7031 36.2198C14.6065 36.2297 14.5176 36.277 14.4363 36.3617L15.1013 36.8393Z'
														fill='#333333'
													/>
													<path
														d='M17.4983 20.9065C17.6167 20.9065 17.676 20.8731 17.676 20.8017C17.676 20.7452 17.5787 20.699 17.386 20.6653C17.1385 20.6205 17.0115 20.5115 17.0093 20.3374C17.0093 20.0982 17.1995 19.9849 17.4559 19.9808C17.5998 19.9808 17.7141 20.0122 17.7988 20.0751C17.8814 20.1401 17.9259 20.2304 17.9321 20.3457H17.7545C17.6889 20.3437 17.6465 20.3206 17.6296 20.2766C17.6105 20.2283 17.5535 20.201 17.4602 20.201C17.35 20.201 17.2947 20.2308 17.2947 20.2871C17.2947 20.3433 17.3667 20.3877 17.5127 20.415C17.703 20.4527 17.8281 20.501 17.8895 20.5577C17.915 20.5838 17.9351 20.6146 17.9485 20.6484C17.962 20.6823 17.9685 20.7184 17.9678 20.7547C17.9678 21.0275 17.7518 21.1281 17.4556 21.1281C17.2993 21.1281 17.1808 21.0951 17.1044 21.0296C17.0197 20.9667 16.9775 20.8701 16.9775 20.7422H17.2653C17.2717 20.8638 17.3605 20.9058 17.4983 20.9058'
														fill='#333333'
													/>
													<path
														d='M18.3675 20.2866H18.0866C18.1203 20.0814 18.266 19.9808 18.5238 19.9808C18.8322 19.9808 18.9884 20.0814 18.9947 20.2866V20.663C18.9947 20.9688 18.809 21.105 18.5069 21.1258C18.2379 21.1468 18.0527 21.0232 18.0527 20.7782C18.0589 20.5128 18.2534 20.4414 18.5365 20.4142C18.6569 20.3995 18.7181 20.364 18.7181 20.3032C18.7118 20.2404 18.6526 20.2091 18.5365 20.2091C18.4371 20.2091 18.3822 20.2342 18.3675 20.2866ZM18.7223 20.6508V20.5482C18.65 20.5777 18.5751 20.6001 18.4985 20.6152C18.3865 20.6362 18.3295 20.6886 18.3295 20.7702C18.3358 20.8582 18.3822 20.9001 18.471 20.9001C18.6273 20.9001 18.7223 20.8078 18.7223 20.6508Z'
														fill='#333333'
													/>
													<path
														d='M19.4662 19.8152V21.104H19.1885V19.6789H19.3325C19.3681 19.6796 19.402 19.6943 19.427 19.7197C19.452 19.7452 19.4661 19.7795 19.4662 19.8152Z'
														fill='#333333'
													/>
													<path
														d='M20.1044 21.1281C19.7662 21.1176 19.5977 20.9233 19.5977 20.5471C19.5977 20.1709 19.769 19.9835 20.1093 19.9808C20.4644 19.9808 20.632 20.1961 20.6103 20.6287H19.8867C19.8973 20.7979 19.9712 20.8836 20.1084 20.8836C20.1738 20.8836 20.2351 20.8565 20.2902 20.8042C20.3022 20.7911 20.3169 20.7808 20.3333 20.7739C20.3497 20.7671 20.3674 20.7638 20.3852 20.7644H20.5924C20.5311 20.9993 20.3789 21.1281 20.1041 21.1281M19.891 20.4302H20.3116C20.2946 20.2838 20.225 20.2086 20.1044 20.2086C19.9839 20.2086 19.912 20.2838 19.891 20.4302Z'
														fill='#333333'
													/>
													<path
														d='M21.2294 20.9058C21.348 20.9058 21.4071 20.8723 21.4071 20.8009C21.4071 20.7444 21.3098 20.6982 21.1173 20.6645C20.8697 20.6205 20.7427 20.5115 20.7407 20.3374C20.7407 20.0982 20.9309 19.9849 21.1871 19.9808C21.331 19.9808 21.4453 20.0122 21.5299 20.0751C21.6124 20.1401 21.6568 20.2304 21.6632 20.3457H21.4854C21.4199 20.3437 21.3776 20.3206 21.3606 20.2766C21.3416 20.2283 21.2844 20.201 21.1914 20.201C21.0813 20.201 21.0263 20.2304 21.0263 20.2871C21.0263 20.3438 21.0983 20.3877 21.2443 20.415C21.4345 20.4527 21.5596 20.501 21.6209 20.5577C21.6464 20.5838 21.6665 20.6147 21.6799 20.6485C21.6934 20.6823 21.6999 20.7184 21.6993 20.7547C21.6993 21.0275 21.4833 21.1281 21.1871 21.1281C21.0305 21.1281 20.912 21.0947 20.8358 21.0296C20.7511 20.9667 20.709 20.8701 20.709 20.7422H20.9975C21.0038 20.8638 21.0926 20.9058 21.2302 20.9058'
														fill='#333333'
													/>
													<path
														d='M21.8215 20.4517V21.0999H22.1057V20.3955C22.1078 20.2809 22.1709 20.2247 22.2952 20.2247C22.4195 20.2247 22.4828 20.2809 22.4891 20.3955V21.0999H22.7716V20.3997C22.7737 20.2851 22.837 20.228 22.9611 20.228C23.0852 20.228 23.1487 20.2843 23.1551 20.3997V20.9666C23.1551 21.054 23.2015 21.0977 23.2941 21.104H23.4396V20.4559C23.4416 20.1413 23.2836 19.9849 22.9659 19.9849C22.8225 19.9849 22.7132 20.0141 22.6328 20.0745C22.5526 20.012 22.4433 19.9808 22.2998 19.9808C21.9814 19.9808 21.8213 20.1369 21.8213 20.4517'
														fill='url(#paint0_linear_15767_406)'
													/>
													<path
														d='M24.1714 19.993C23.7891 19.993 23.5925 20.1714 23.584 20.5306V21.104H23.8752V20.5264C23.8752 20.3646 23.9551 20.2828 24.1149 20.2828H24.212V19.993H24.1714Z'
														fill='url(#paint1_linear_15767_406)'
													/>
													<path
														d='M25.3594 19.6789V20.8958C25.3573 21.0201 25.4089 21.0851 25.5166 21.0958C25.6168 21.106 25.7179 21.1067 25.8183 21.098V20.8854H25.7296C25.6737 20.8854 25.6456 20.86 25.6456 20.8138V20.1969H25.6757C25.6946 20.1973 25.7133 20.194 25.7308 20.1871C25.7483 20.1803 25.7642 20.17 25.7775 20.157C25.7908 20.1439 25.8013 20.1284 25.8083 20.1113C25.8153 20.0942 25.8187 20.0759 25.8183 20.0575V19.9969H25.6459V19.8199C25.6459 19.7463 25.5834 19.6789 25.5081 19.6789H25.3594Z'
														fill='url(#paint2_linear_15767_406)'
													/>
													<path
														d='M24.3447 19.6789V21.104H24.6248V20.6996C24.6237 20.6866 24.6277 20.6737 24.6359 20.6635C24.6441 20.6534 24.6559 20.6468 24.6689 20.6451C24.7048 20.6451 24.7406 20.6765 24.7763 20.7393L24.974 21.104H25.3109L24.9215 20.4467L25.3066 20.0352H24.9699L24.8452 20.1776L24.6967 20.3471L24.6248 20.4292V19.8152C24.6246 19.7795 24.6104 19.7452 24.5852 19.7197C24.5601 19.6943 24.5259 19.6796 24.49 19.6789H24.3447Z'
														fill='url(#paint3_linear_15767_406)'
													/>
												</g>
												<defs>
													<filter
														id='filter0_d_15767_406'
														x='1.09277'
														y='0.588776'
														width='40.4912'
														height='40.664'
														filterUnits='userSpaceOnUse'
														color-interpolation-filters='sRGB'>
														<feFlood
															flood-opacity='0'
															result='BackgroundImageFix'
														/>
														<feColorMatrix
															in='SourceAlpha'
															type='matrix'
															values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
															result='hardAlpha'
														/>
														<feOffset
															dx='0.129707'
															dy='0.324268'
														/>
														<feGaussianBlur stdDeviation='0.0162134' />
														<feComposite
															in2='hardAlpha'
															operator='out'
														/>
														<feColorMatrix
															type='matrix'
															values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0'
														/>
														<feBlend
															mode='normal'
															in2='BackgroundImageFix'
															result='effect1_dropShadow_15767_406'
														/>
														<feBlend
															mode='normal'
															in='SourceGraphic'
															in2='effect1_dropShadow_15767_406'
															result='shape'
														/>
													</filter>
													<filter
														id='filter1_d_15767_406'
														x='0.606372'
														y='0.232081'
														width='41.3019'
														height='41.2801'
														filterUnits='userSpaceOnUse'
														color-interpolation-filters='sRGB'>
														<feFlood
															flood-opacity='0'
															result='BackgroundImageFix'
														/>
														<feColorMatrix
															in='SourceAlpha'
															type='matrix'
															values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
															result='hardAlpha'
														/>
														<feOffset dy='0.129707' />
														<feGaussianBlur stdDeviation='0.243201' />
														<feComposite
															in2='hardAlpha'
															operator='out'
														/>
														<feColorMatrix
															type='matrix'
															values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
														/>
														<feBlend
															mode='normal'
															in2='BackgroundImageFix'
															result='effect1_dropShadow_15767_406'
														/>
														<feBlend
															mode='normal'
															in='SourceGraphic'
															in2='effect1_dropShadow_15767_406'
															result='shape'
														/>
													</filter>
													<linearGradient
														id='paint0_linear_15767_406'
														x1='22.6309'
														y1='21.1086'
														x2='22.6309'
														y2='19.6458'
														gradientUnits='userSpaceOnUse'>
														<stop stop-color='#3BB54A' />
														<stop
															offset='0.06'
															stop-color='#4EBA47'
														/>
														<stop
															offset='0.17'
															stop-color='#70C242'
														/>
														<stop
															offset='0.3'
															stop-color='#8CC93E'
														/>
														<stop
															offset='0.43'
															stop-color='#A1CE3A'
														/>
														<stop
															offset='0.58'
															stop-color='#B0D238'
														/>
														<stop
															offset='0.75'
															stop-color='#B9D436'
														/>
														<stop
															offset='1'
															stop-color='#BCD536'
														/>
													</linearGradient>
													<linearGradient
														id='paint1_linear_15767_406'
														x1='23.8982'
														y1='21.1128'
														x2='23.8982'
														y2='19.6384'
														gradientUnits='userSpaceOnUse'>
														<stop stop-color='#3BB54A' />
														<stop
															offset='0.06'
															stop-color='#4EBA47'
														/>
														<stop
															offset='0.17'
															stop-color='#70C242'
														/>
														<stop
															offset='0.3'
															stop-color='#8CC93E'
														/>
														<stop
															offset='0.43'
															stop-color='#A1CE3A'
														/>
														<stop
															offset='0.58'
															stop-color='#B0D238'
														/>
														<stop
															offset='0.75'
															stop-color='#B9D436'
														/>
														<stop
															offset='1'
															stop-color='#BCD536'
														/>
													</linearGradient>
													<linearGradient
														id='paint2_linear_15767_406'
														x1='25.5888'
														y1='21.1195'
														x2='25.5888'
														y2='19.6415'
														gradientUnits='userSpaceOnUse'>
														<stop stop-color='#3BB54A' />
														<stop
															offset='0.06'
															stop-color='#4EBA47'
														/>
														<stop
															offset='0.17'
															stop-color='#70C242'
														/>
														<stop
															offset='0.3'
															stop-color='#8CC93E'
														/>
														<stop
															offset='0.43'
															stop-color='#A1CE3A'
														/>
														<stop
															offset='0.58'
															stop-color='#B0D238'
														/>
														<stop
															offset='0.75'
															stop-color='#B9D436'
														/>
														<stop
															offset='1'
															stop-color='#BCD536'
														/>
													</linearGradient>
													<linearGradient
														id='paint3_linear_15767_406'
														x1='24.8279'
														y1='21.1112'
														x2='24.8279'
														y2='19.6401'
														gradientUnits='userSpaceOnUse'>
														<stop stop-color='#3BB54A' />
														<stop
															offset='0.06'
															stop-color='#4EBA47'
														/>
														<stop
															offset='0.17'
															stop-color='#70C242'
														/>
														<stop
															offset='0.3'
															stop-color='#8CC93E'
														/>
														<stop
															offset='0.43'
															stop-color='#A1CE3A'
														/>
														<stop
															offset='0.58'
															stop-color='#B0D238'
														/>
														<stop
															offset='0.75'
															stop-color='#B9D436'
														/>
														<stop
															offset='1'
															stop-color='#BCD536'
														/>
													</linearGradient>
												</defs>
											</svg>
										</div>
									</a>
								</div>
								<a
									className=' text-sm text-center pb-3 flex lg:hidden  items-center justify-center font-semibold hover:text-lime-500 transition-all duration-300 right-0'
									href='https://www.shopify.com/news/hot-take-b2b-is-the-biggest-commerce-opportunity-of-2024'
									target='_blank'
									rel='noopener noreferrer'>
									Why 2024 is the Year of B2B Commerce {'>'}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer
				LetsTalkOpener={LetsTalkOpener}
				setLetsTalkOpener={setLetsTalkOpener}
				LoginMenuOpener={LoginMenuOpener}
				setLoginMenuOpener={setLoginMenuOpener}
				Four={navFour}
				setFour={setNavFour}
				numberId={FooterSelected}
				setNumber={setFooterSelected}
				recources={resources}
				budnles={bundles}
				setBundles={setBundles}
				setOne={setNavOne}
				setTwo={setNavTwo}
				setThree={setNavThree}
				One={navOne}
				Two={navTwo}
				Three={navThree}
				setExploreButton={setExploreButton}
				setRecources={setresources}
			/>
		</div>
	);
};

export default SalesmrktOverviewNew;
